import React from "react";
import PropTypes from "prop-types";
import { WIDGET } from "../../constants/route-constants";
import { color } from "highcharts";

export const DashboardIcon = () => (
  <svg
    className="icon DashboardIcon"
    width="19"
    height="18"
    viewBox="0 0 19 18"
  >
    <g>
      <path
        d="M3.611 11.111h5c.458 0 .833-.375.833-.833V3.61c0-.458-.375-.833-.833-.833h-5c-.458 0-.833.375-.833.833v6.667c0 .458.375.833.833.833zm0 6.667h5c.458 0 .833-.375.833-.834v-3.333c0-.458-.375-.833-.833-.833h-5c-.458 0-.833.375-.833.833v3.333c0 .459.375.834.833.834zm8.333 0h5c.459 0 .834-.375.834-.834v-6.666c0-.459-.375-.834-.834-.834h-5c-.458 0-.833.375-.833.834v6.666c0 .459.375.834.833.834zM11.111 3.61v3.333c0 .459.375.834.833.834h5c.459 0 .834-.375.834-.834V3.611c0-.458-.375-.833-.834-.833h-5c-.458 0-.833.375-.833.833z"
        transform="translate(-31 -203) translate(20 192) translate(11 11)"
      />
    </g>
  </svg>
);

export const TopicsIcon = () => (
  <svg className="icon TopicsIcon" width="20" height="18" viewBox="0 0 20 18">
    <g>
      <path d="M16.875 0H3.125C1.4.002.002 1.44 0 3.214v9.643c.002 1.775 1.4 3.212 3.125 3.214h4.74l1.693 1.74c.244.252.64.252.884 0l1.692-1.74h4.741c1.725-.002 3.123-1.44 3.125-3.214V3.214C19.998 1.44 18.6.002 16.875 0zm1.875 12.857c-.001 1.065-.84 1.928-1.875 1.929h-5c-.166 0-.325.068-.442.188L10 16.448l-1.433-1.474c-.117-.12-.276-.188-.442-.188h-5c-1.035-.001-1.874-.864-1.875-1.929V3.214c.001-1.064.84-1.927 1.875-1.928h13.75c1.035 0 1.874.864 1.875 1.928v9.643z" />
      <path d="M13.75 7.071c.345 0 .625-.287.625-.642 0-.355-.28-.643-.625-.643H12.5V3.857c0-.355-.28-.643-.625-.643s-.625.288-.625.643v1.929h-2.5V3.857c0-.355-.28-.643-.625-.643s-.625.288-.625.643v1.929H6.25c-.345 0-.625.288-.625.643 0 .355.28.642.625.642H7.5V9H6.25c-.345 0-.625.288-.625.643 0 .355.28.643.625.643H7.5v1.928c0 .355.28.643.625.643s.625-.288.625-.643v-1.928h2.5v1.928c0 .355.28.643.625.643s.625-.288.625-.643v-1.928h1.25c.345 0 .625-.288.625-.643 0-.355-.28-.643-.625-.643H12.5V7.071h1.25zM11.25 9h-2.5V7.071h2.5V9z" />
    </g>
  </svg>
);

export const PrintOnlineIcon = () => (
  <svg
    className="icon PrintOnlineIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fillRule="evenodd">
      <path
        d="M14.19 3.305l-.002-.015c-.02-.028-.044-.052-.064-.08-.146-.198-.3-.39-.463-.573l-.136-.15c-.168-.18-.344-.351-.528-.514-.034-.03-.066-.062-.1-.091-.454-.39-.952-.725-1.482-1.001-.022-.011-.044-.02-.066-.032-.236-.12-.479-.228-.726-.323-.056-.02-.107-.04-.16-.056-.22-.08-.443-.149-.67-.209C9.726.244 9.659.225 9.59.21 9.367.158 9.144.118 8.915.085c-.069-.01-.137-.023-.207-.031-.588-.072-1.183-.072-1.772 0-.07.008-.138.021-.207.031-.228.033-.454.073-.675.124-.068.016-.135.035-.202.052-.229.06-.452.13-.67.209l-.16.056c-.248.095-.49.203-.727.323-.021.011-.044.02-.065.032-.532.276-1.032.611-1.487 1-.035.03-.066.062-.1.092-.187.164-.363.335-.529.514l-.135.15c-.164.183-.318.374-.464.574-.02.027-.044.051-.063.079l-.007.015c-1.927 2.7-1.927 6.326 0 9.026l.007.015c.02.028.043.052.063.079.146.199.3.39.464.574l.135.15c.168.18.345.35.529.514.034.03.065.061.1.09.454.39.951.726 1.482 1.002.021.01.044.02.065.032.237.12.48.228.727.323.055.02.106.04.16.056.22.08.443.149.67.208.067.018.134.037.202.052.223.052.447.092.675.124.07.01.137.024.207.032.589.072 1.184.072 1.772 0 .07-.008.138-.022.207-.032.229-.032.454-.072.676-.124.068-.015.135-.034.202-.052.229-.06.452-.129.67-.208l.16-.056c.247-.095.49-.203.726-.323.022-.012.044-.021.065-.032.531-.276 1.029-.612 1.483-1.001l.1-.091c.186-.164.362-.335.528-.515.046-.049.09-.099.135-.149.164-.184.319-.375.464-.574.02-.027.044-.051.064-.08l.006-.014c1.927-2.7 1.927-6.326 0-9.026zm-.638 1.057c.534.88.857 1.872.942 2.897H11.15c-.041-.665-.146-1.325-.313-1.97.945-.178 1.86-.49 2.716-.927zm-4.31-3.093c.03.007.06.017.092.025.2.047.398.1.592.167.03.01.059.022.088.033.192.067.381.141.567.223l.096.047c.178.085.351.176.52.274l.113.068c.16.098.317.203.469.316.039.028.078.055.116.087.15.111.292.231.428.359.036.032.073.064.108.098.143.135.28.279.411.427.017.02.035.038.052.056-.757.36-1.558.618-2.383.766-.382-1.05-.886-2.052-1.503-2.984.077.014.157.021.233.038zM5.605 7.26c.044-.604.147-1.203.307-1.787.633.075 1.27.112 1.907.112.638 0 1.275-.039 1.909-.115.16.585.262 1.185.305 1.79H5.606zm4.428 1.117c-.044.605-.147 1.203-.307 1.788-.633-.075-1.27-.113-1.907-.112-.638 0-1.275.037-1.909.112-.16-.585-.262-1.183-.305-1.788h4.428zM7.82 1.48c.636.901 1.159 1.877 1.557 2.905-.517.055-1.037.082-1.557.082s-1.038-.028-1.555-.083c.399-1.027.92-2.002 1.555-2.904zM2.798 3.393c.132-.149.269-.292.412-.428.035-.034.072-.065.107-.098.138-.125.28-.245.428-.359.039-.03.078-.056.117-.087.152-.112.308-.217.47-.316l.11-.067c.17-.1.344-.19.521-.275l.097-.046c.186-.084.375-.159.567-.224.03-.01.056-.022.088-.032.194-.065.39-.119.592-.168.031-.007.061-.017.093-.024.077-.017.156-.024.234-.038-.617.932-1.122 1.933-1.505 2.984-.824-.147-1.626-.405-2.382-.765l.051-.057zm-.71.969c.856.437 1.77.75 2.716.926-.167.646-.272 1.306-.312 1.971H1.146c.085-1.025.408-2.017.942-2.897zm0 6.912c-.534-.88-.857-1.872-.942-2.898h3.346c.04.666.145 1.326.312 1.972-.945.177-1.86.489-2.716.926zm4.311 3.093c-.031-.008-.061-.018-.093-.025-.2-.047-.398-.1-.592-.168l-.087-.032c-.193-.067-.382-.141-.567-.223l-.097-.047c-.178-.085-.351-.176-.52-.275l-.112-.067c-.161-.098-.318-.204-.47-.316-.039-.028-.078-.056-.116-.087-.15-.112-.292-.231-.428-.36-.036-.031-.073-.063-.108-.097-.143-.136-.28-.28-.411-.428l-.051-.056c.756-.36 1.557-.617 2.382-.765.382 1.05.887 2.052 1.503 2.984-.077-.014-.156-.022-.233-.038zm1.421-.21c-.636-.901-1.158-1.877-1.557-2.905 1.035-.111 2.078-.111 3.113 0-.4 1.028-.922 2.003-1.556 2.905zm5.022-1.914c-.132.148-.268.292-.411.428l-.108.098c-.138.125-.28.245-.428.359l-.117.087c-.152.112-.308.217-.47.315l-.11.068c-.17.099-.343.19-.521.274l-.097.047c-.185.084-.375.158-.567.224-.029.01-.056.022-.088.032-.193.065-.39.118-.592.168-.031.007-.061.017-.093.024-.077.016-.156.024-.234.038.617-.932 1.122-1.933 1.504-2.984.825.148 1.626.405 2.382.766-.016.018-.034.036-.05.056zm.71-.97c-.856-.436-1.77-.748-2.716-.925.167-.646.272-1.306.313-1.972h3.345c-.085 1.026-.408 2.018-.942 2.898z"
        transform="translate(-33 -311) translate(-1 14) translate(34 293) translate(0 4)"
      />
    </g>
  </svg>
);

export const SocialBlogIcon = () => (
  <svg
    className="icon SocialBlogIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fillRule="evenodd">
      <path
        d="M3.749 16H1.261c-.69 0-1.25-.561-1.25-1.251V7.251C.01 6.561.57 6 1.26 6H4.5c.276 0 .5.224.5.5v8.249C5 15.439 4.439 16 3.749 16zM1.261 7c-.138 0-.25.112-.25.251v7.498c0 .138.112.251.25.251h2.488c.139 0 .251-.113.251-.251V7H1.261z"
        transform="translate(-33 -363) translate(-1 14) translate(34 345) translate(0 4)"
      />
      <path
        d="M13.439 16H7.565c-.774 0-1.549-.182-2.241-.529l-1.047-.524c-.248-.123-.348-.424-.224-.671.123-.247.425-.346.671-.223l1.047.523c.554.277 1.175.424 1.794.424h5.874c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.096-.114-.236-.179-.382-.179-.277 0-.5-.223-.5-.5s.223-.5.5-.5h.439c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.096-.114-.236-.179-.382-.179-.277 0-.5-.223-.5-.5s.223-.5.5-.5h.206c.36 0 .681-.227.766-.54.086-.322-.042-.554-.127-.664-.144-.188-.361-.296-.595-.296-.277 0-.5-.223-.5-.5s.223-.5.5-.5c.234 0 .451-.108.595-.296.085-.11.213-.342.127-.664-.085-.313-.406-.54-.766-.54H9.5c-.16 0-.312-.077-.406-.208-.094-.13-.12-.298-.069-.45l.778-2.332c.122-.37.165-.769.122-1.155-.079-.714-.453-1.372-1.027-1.805-.152-.116-.398.008-.398.199v.487c0 .927-.313 1.838-.881 2.569L4.894 7.807c-.17.218-.484.256-.701.088-.219-.17-.258-.484-.089-.702l2.724-3.502c.433-.556.671-1.25.671-1.954v-.488C7.5.56 8.06 0 8.749 0c.27 0 .537.09.752.253.792.598 1.309 1.507 1.418 2.492.059.528.001 1.075-.167 1.581L10.194 6h4.012c.818 0 1.53.527 1.732 1.281.144.538.035 1.096-.299 1.532-.052.066-.107.129-.166.187.059.058.114.12.166.188.334.435.443.993.299 1.53-.107.398-.355.732-.684.959.207.315.289.698.225 1.077-.07.416-.327.773-.68.996.174.3.239.654.18 1.004-.12.71-.782 1.246-1.54 1.246z"
        transform="translate(-33 -363) translate(-1 14) translate(34 345) translate(0 4)"
      />
    </g>
  </svg>
);

export const SocialForumIcon = () => (
  <svg
    className="icon SocialForumIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="12"
    viewBox="0 0 16 12"
  >
    <g fill="" fill-rule="nonzero">
      <path
        d="M14.507 2.114h-4.81v-.605C9.698.765 9.094.16 8.35.16H1.493C.75.16.145.765.145 1.51V6.07c0 .743.605 1.348 1.348 1.348h.812l-.09 1.592c-.009.172.086.333.241.408.06.028.122.042.185.042.102 0 .204-.038.284-.109l2.16-1.933h1.218v.605c0 .744.605 1.349 1.348 1.349h3.266l2.159 1.933c.08.071.18.108.283.108h.004c.235 0 .425-.19.425-.425 0-.027-.002-.053-.007-.078l-.086-1.538h.812c.743 0 1.348-.605 1.348-1.349V3.462c0-.743-.605-1.348-1.348-1.348zM4.921 6.568c-.104 0-.206.039-.284.109L3.123 8.032l.057-1.015c.006-.117-.036-.23-.116-.316-.08-.085-.192-.133-.31-.133h-1.26c-.275 0-.498-.223-.498-.497V1.51c0-.274.223-.498.497-.498H8.35c.274 0 .498.224.498.498v.605H7.65c-.744 0-1.348.605-1.348 1.348v3.106H4.92zm10.083 1.456c0 .274-.223.498-.497.498h-1.262c-.116 0-.228.048-.309.133-.08.085-.122.199-.115.316l.056 1.015-1.514-1.356c-.078-.07-.18-.109-.284-.109H7.651c-.274 0-.497-.223-.497-.497V3.462c0-.274.223-.497.497-.497h6.856c.274 0 .497.223.497.497v4.562z"
        transform="translate(-935 -152) translate(766 144) translate(16) translate(146) translate(7 8)"
      />
    </g>
  </svg>
);

export const TagsIcon = () => (
  <svg
    className="icon TagsIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill-rule="evenodd">
      <g transform="translate(-280 -640) translate(266 364) translate(14 276)">
        <path
          fill-rule="nonzero"
          d="M.44 9.598l.904.904 1.929 1.928 1.776 1.776.469.47.065.065c.389.38.978.546 1.504.378.248-.08.464-.212.648-.394l.103-.103.445-.445L9.89 12.57l2.025-2.025 1.81-1.81.978-.978c.31-.31.5-.722.481-1.168-.009-.224-.019-.45-.03-.673l-.116-2.705-.05-1.13c-.01-.256-.002-.54-.077-.787-.155-.498-.57-.924-1.088-1.038-.138-.03-.277-.041-.416-.046l-.84-.036L9.823.056 8.808.011l-.219-.01c-.409-.015-.802.144-1.1.421-.245.229-.476.475-.713.712L5.098 2.81 3.072 4.838 1.317 6.593c-.287.287-.574.572-.86.86-.185.187-.323.412-.397.666-.158.521.004 1.09.38 1.479.251.257.724.271.973 0 .255-.279.268-.697 0-.973-.022-.024-.045-.048-.065-.074l.108.14c-.045-.06-.08-.121-.11-.187l.069.165c-.028-.065-.045-.134-.057-.202.009.06.017.122.024.182-.01-.078-.01-.155 0-.234l-.024.182c.01-.07.03-.137.057-.203l-.069.165c.03-.067.065-.128.11-.185l-.108.139c.072-.09.161-.17.242-.25l.506-.506 1.69-1.69 2.043-2.044L7.59 2.261c.28-.28.558-.562.84-.84.03-.03.059-.055.091-.08l-.139.107c.059-.043.12-.079.188-.108l-.166.069c.07-.026.138-.045.21-.055l-.182.024c.194-.02.399.005.593.014l1.18.051c.902.04 1.8.08 2.701.117.219.01.444.007.66.033-.06-.009-.122-.017-.182-.024.07.01.136.027.201.053l-.165-.069c.07.03.136.067.196.114l-.14-.109c.054.043.1.09.144.143l-.109-.14c.047.06.084.126.114.197l-.069-.165c.026.065.043.132.053.2l-.024-.181c.02.18.02.367.028.55l.051 1.193.117 2.69c.01.228.043.472.019.703.009-.06.017-.122.024-.182-.01.072-.027.14-.055.21.022-.056.047-.11.069-.166-.03.067-.064.13-.108.188l.108-.14c-.074.093-.165.176-.25.26l-.505.505-1.69 1.69-2.043 2.044-1.762 1.762c-.28.28-.559.562-.84.84-.026.026-.054.05-.083.074l.14-.108c-.06.044-.121.08-.186.11l.165-.069c-.066.027-.134.045-.203.057.06-.009.122-.018.182-.024-.077.01-.155.01-.234 0l.182.024c-.07-.01-.137-.03-.202-.057l.165.069c-.067-.03-.13-.066-.186-.11l.14.108c-.204-.165-.38-.371-.565-.555l-1.222-1.222-1.492-1.492-1.3-1.3c-.209-.21-.417-.424-.63-.63l-.009-.01c-.254-.254-.722-.273-.972 0-.251.276-.27.7.001.974z"
        />
        <circle cx="11.81" cy="3.374" r="1" />
      </g>
    </g>
  </svg>
);

export const NotificationsMenuIcon = () => (
  <svg
    className="icon NotificationsMenuIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="18"
    viewBox="0 0 14 18"
  >
    <g fillRule="evenodd">
      <path
        d="M13.654 14.006c-.052-.033-.441-.306-.831-1.131-.716-1.516-.866-3.65-.866-5.174v-.02c-.009-2.014-1.215-3.75-2.94-4.53v-1.19C9.017.88 8.139 0 7.059 0h-.162C5.817 0 4.94.88 4.94 1.96v1.192C3.208 3.933 2 5.678 2 7.7c0 1.524-.15 3.658-.867 5.174-.39.825-.779 1.098-.83 1.131-.219.101-.326.334-.276.57.05.239.274.403.517.403h3.78c.02 1.449 1.203 2.621 2.654 2.621 1.451 0 2.634-1.172 2.655-2.62h3.78c.243 0 .466-.165.516-.404.05-.236-.057-.469-.275-.57zM5.97 1.961c0-.512.415-.928.926-.928h.162c.51 0 .926.416.926.928v.856c-.325-.067-.662-.103-1.007-.103-.345 0-.682.036-1.007.103v-.856zm1.007 14.606c-.882 0-1.602-.709-1.623-1.588H8.6c-.02.88-.74 1.588-1.623 1.588zm2.076-2.62H1.72c.09-.14.18-.297.27-.475.692-1.363 1.042-3.304 1.042-5.771 0-2.18 1.77-3.954 3.947-3.954 2.176 0 3.947 1.774 3.947 3.956v.019c.002 2.456.353 4.391 1.042 5.75.09.178.18.335.27.474H9.054z"
        transform="translate(-33 -466) translate(-1 14) translate(34 449) translate(0 3)"
      />
    </g>
  </svg>
);

export const ProfileIcon = () => (
  <svg
    className="icon ProfileIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    viewBox="0 0 15 15"
  >
    <g fill-rule="evenodd">
      <path
        d="M7.46 8.857c-2.208 0-4-1.807-4-4.006 0-2.2 1.792-3.994 4-3.994 2.21 0 4 1.782 4 3.994s-1.79 4.006-4 4.006zm.06-7.038c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zM.53 15c-.296 0-.53-.23-.53-.519 0-2.728 2.266-4.936 5.037-4.936h4.926c2.783 0 5.037 2.22 5.037 4.936 0 .29-.234.519-.53.519H.53zm4.201-4.48c-1.685 0-2.941 1.76-3.157 3.442h11.921c-.216-1.693-2.142-3.442-3.827-3.442H4.731z"
        transform="translate(-281 -749) translate(278 746) translate(3 3)"
      />
    </g>
  </svg>
);

export const OrgArrowIcon = () => (
  <svg
    className="icon OrgArrowIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="7"
    viewBox="0 0 10 7"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#888">
        <path
          d="M130.85 38.525l-4.488-4.66c-.2-.207-.524-.207-.724 0l-4.488 4.66c-.2.207-.2.543 0 .75l.361.376c.2.207.524.207.724 0L126 35.74l3.766 3.91c.2.207.523.207.723 0l.361-.375c.2-.208.2-.544 0-.751z"
          transform="translate(-570 -310) translate(373 186) translate(20 91) translate(56) rotate(180 126 36.758)"
        />
      </g>
    </g>
  </svg>
);

export const NotificationsIcon = () => (
  <svg
    className="icon NotificationsIcon"
    width="19"
    height="23"
    viewBox="0 0 19 23"
  >
    <path d="M17.808 15.494l-1.04-1.293c-.647-.814-.994-1.844-.994-2.898V8.884c0-3.496-2.543-6.393-5.803-6.825V.862C9.971.383 9.601 0 9.14 0c-.462 0-.832.383-.832.862V2.06c-3.26.432-5.803 3.33-5.803 6.825v2.42c0 1.053-.347 2.083-.994 2.897L.493 15.494c-.532.67-.648 1.604-.278 2.395.37.79 1.11 1.293 1.965 1.293h3.19c.186 2.011 1.804 3.568 3.792 3.568 1.988 0 3.607-1.58 3.791-3.568h3.19c.856 0 1.596-.503 1.966-1.293.323-.79.231-1.7-.3-2.395zm-8.66 5.631c-1.005 0-1.836-.708-1.989-1.625h3.978c-.153.917-.984 1.625-1.989 1.625zm7.508-3.563c-.047.096-.164.313-.467.313H2.11c-.302 0-.419-.217-.466-.313-.046-.096-.116-.337.07-.577l1.026-1.3c.886-1.13 1.375-2.55 1.375-4.018V9.26c.024-2.863 2.262-5.197 5.036-5.197 2.773 0 5.011 2.334 5.011 5.173v2.43c0 1.468.49 2.888 1.376 4.02l1.025 1.299c.21.24.14.48.094.577z" />
  </svg>
);

export const SocialAccountsIcon = () => (
  <svg
    className="icon SocialAccountsIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill-rule="evenodd">
      <path
        d="M3.749 16H1.261c-.69 0-1.25-.561-1.25-1.251V7.251C.01 6.561.57 6 1.26 6H4.5c.276 0 .5.224.5.5v8.249C5 15.439 4.439 16 3.749 16zM1.261 7c-.138 0-.25.112-.25.251v7.498c0 .138.112.251.25.251h2.488c.139 0 .251-.113.251-.251V7H1.261z"
        transform="translate(-406 -483) translate(373 186) translate(33 293) translate(0 4)"
      />
      <path
        d="M13.439 16H7.565c-.774 0-1.549-.182-2.241-.529l-1.047-.524c-.248-.123-.348-.424-.224-.671.123-.247.425-.346.671-.223l1.047.523c.554.277 1.175.424 1.794.424h5.874c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.096-.114-.236-.179-.382-.179-.277 0-.5-.223-.5-.5s.223-.5.5-.5h.439c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.096-.114-.236-.179-.382-.179-.277 0-.5-.223-.5-.5s.223-.5.5-.5h.206c.36 0 .681-.227.766-.54.086-.322-.042-.554-.127-.664-.144-.188-.361-.296-.595-.296-.277 0-.5-.223-.5-.5s.223-.5.5-.5c.234 0 .451-.108.595-.296.085-.11.213-.342.127-.664-.085-.313-.406-.54-.766-.54H9.5c-.16 0-.312-.077-.406-.208-.094-.13-.12-.298-.069-.45l.778-2.332c.122-.37.165-.769.122-1.155-.079-.714-.453-1.372-1.027-1.805-.152-.116-.398.008-.398.199v.487c0 .927-.313 1.838-.881 2.569L4.894 7.807c-.17.218-.484.256-.701.088-.219-.17-.258-.484-.089-.702l2.724-3.502c.433-.556.671-1.25.671-1.954v-.488C7.5.56 8.06 0 8.749 0c.27 0 .537.09.752.253.792.598 1.309 1.507 1.418 2.492.059.528.001 1.075-.167 1.581L10.194 6h4.012c.818 0 1.53.527 1.732 1.281.144.538.035 1.096-.299 1.532-.052.066-.107.129-.166.187.059.058.114.12.166.188.334.435.443.993.299 1.53-.107.398-.355.732-.684.959.207.315.289.698.225 1.077-.07.416-.327.773-.68.996.174.3.239.654.18 1.004-.12.71-.782 1.246-1.54 1.246z"
        transform="translate(-406 -483) translate(373 186) translate(33 293) translate(0 4)"
      />
    </g>
  </svg>
);

export const BlogForumsIcon = () => (
  <svg
    className="icon BlogForumsIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="14"
    viewBox="0 0 17 14"
  >
    <g fill-rule="evenodd">
      <path
        d="M1.331 0C.604 0 0 .604 0 1.331v10.415c0 .727.604 1.33 1.331 1.33h10.415c.727 0 1.33-.603 1.33-1.33V8.459l3.574-3.567c.105-.105.165-.248.165-.397 0-.149-.06-.292-.165-.397l-1.693-1.693c-.107-.106-.252-.165-.403-.163-.147 0-.287.06-.391.163l-1.086 1.086v-2.16C13.077.604 12.473 0 11.746 0H1.33zm0 1.12h10.415c.127 0 .21.084.21.211v3.287l-3.2 3.205c-.104.105-.163.248-.163.397V9.9c0 .31.251.56.56.56h1.682c.149 0 .292-.058.397-.163l.724-.724v2.172c0 .127-.083.21-.21.21H1.33c-.127 0-.21-.083-.21-.21V1.33c0-.127.083-.21.21-.21zm1.413 1.495c-.2.01-.38.127-.471.306-.091.178-.08.392.03.56.108.169.299.266.5.255h7.472c.202.003.39-.103.492-.278.102-.174.102-.39 0-.565-.102-.174-.29-.28-.492-.278H2.744zm11.816.981l.899.9-.602.6-.899-.899.602-.6zM2.744 4.857c-.2.01-.38.127-.471.306-.091.178-.08.392.03.56.108.168.299.265.5.255H9.34c.202.003.39-.103.492-.278.102-.174.102-.39 0-.565-.102-.175-.29-.28-.492-.278H2.744zm10.42.134l.9.9-3.462 3.45h-.888v-.888l3.45-3.462zM2.744 7.1c-.2.01-.38.127-.471.305-.091.179-.08.393.03.56.108.17.299.266.5.256h4.483c.202.003.39-.104.492-.278.102-.175.102-.39 0-.565-.102-.175-.29-.281-.492-.278H2.744zm0 2.242c-.2.01-.38.127-.471.305-.091.179-.08.392.03.56.108.169.299.266.5.256h4.483c.202.002.39-.104.492-.278.102-.175.102-.39 0-.565-.102-.175-.29-.281-.492-.278H2.744z"
        transform="translate(-406 -536) translate(373 186) translate(33 345) translate(0 5)"
      />
    </g>
  </svg>
);

export const TvIcon = () => (
  <svg
    className="icon BlogForumsIcon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="17"
    height="14"
  >
    <path d="M512 448H127.1C110.3 448 96 462.3 96 479.1S110.3 512 127.1 512h384C529.7 512 544 497.7 544 480S529.7 448 512 448zM592 0h-544C21.5 0 0 21.5 0 48v320C0 394.5 21.5 416 48 416h544c26.5 0 48-21.5 48-48v-320C640 21.5 618.5 0 592 0zM576 352H64v-288h512V352z" />
  </svg>
);

export const JounalistIcon = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    className="icon BlogForumsIcon"
    viewBox="0 0 247.8 444.2"
    width="17"
    height="14"
  >
    <path
      d="M60.3,444.5L6.8,229c0,0-11.3-27.1-0.8-41.2L92.4,12.6C96.1,5.1,103.7,0.3,112,0.1l0.6,152.2
c-4.6,1.7-8.9,4.3-12.1,7.5c-13.5,13.6-13,34.5,0.2,47.6c13.2,13.1,34,13.5,47.6-0.2c12.6-12.7,13-34.5-0.2-47.6
c-3.7-3.7-8.4-5.8-13.1-7.4L134.4,0c8.4,0.1,16,4.9,19.8,12.4l87.6,174.5c10,14.2-0.6,41.2-0.6,41.2L189,444.6L60.3,444.5z"
    />
  </svg>
);

export const OrganizationInfoIcon = () => (
  <svg
    className="icon OrganizationInfoIcon"
    width="18"
    height="19"
    viewBox="0 0 18 19"
  >
    <path d="M9 .074c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9zm-.614 1.349v3.151H6.021c.144-.416.308-.803.486-1.15.55-1.074 1.213-1.744 1.88-2.001zm1.228 0c.666.257 1.329.927 1.879 2 .178.348.342.735.486 1.151H9.614V1.423zm-3.618.48c-.211.294-.406.614-.582.958-.265.518-.493 1.094-.684 1.713H2.66c.834-1.176 1.987-2.108 3.336-2.672zm6.008 0c1.349.563 2.502 1.495 3.337 2.671H13.27c-.19-.619-.419-1.195-.684-1.713-.176-.344-.371-.664-.582-.959zM1.95 5.8h2.467c-.173.835-.28 1.727-.313 2.66H1.253c.074-.945.316-1.84.697-2.66zm3.726 0h2.71v2.66H5.331c.037-.946.158-1.84.345-2.66zm3.938 0h2.71c.187.82.308 1.714.345 2.66H9.614V5.8zm3.97 0h2.466c.38.82.623 1.715.697 2.66h-2.85c-.033-.933-.141-1.825-.314-2.66zM1.252 9.688h2.85c.033.932.141 1.825.314 2.659H1.95c-.38-.82-.624-1.714-.697-2.66zm4.078 0h3.055v2.659h-2.71c-.186-.819-.308-1.715-.345-2.66zm4.283 0h3.055c-.037.944-.159 1.84-.345 2.659h-2.71v-2.66zm4.282 0h2.851c-.073.945-.317 1.84-.697 2.659h-2.467c.173-.834.28-1.727.313-2.66zM2.66 13.574H4.73c.19.618.419 1.189.684 1.707.179.348.38.672.595.971-1.355-.563-2.512-1.498-3.35-2.678zm3.356 0h2.371v3.151c-.666-.257-1.329-.927-1.879-2-.179-.35-.347-.732-.492-1.15zm3.599 0h2.371c-.145.42-.313.801-.492 1.15-.55 1.074-1.213 1.744-1.88 2.001v-3.15zm3.656 0h2.07c-.837 1.18-1.994 2.115-3.349 2.678.215-.299.416-.623.595-.971.265-.518.493-1.089.684-1.707z" />
  </svg>
);

export const AdminIcon = () => (
  <svg className="icon AdminIcon" width="15" height="17" viewBox="0 0 15 17">
    <path d="M13.846 2.267h-.192c-2.038 0-3.365-.496-5.462-2.04C7.987.076 7.744 0 7.5 0c-.244 0-.487.076-.692.227-2.097 1.544-3.424 2.04-5.462 2.04h-.192C.517 2.267 0 2.774 0 3.4v5.1c0 2.519 1.253 4.787 3.623 6.558 1.714 1.282 3.424 1.858 3.496 1.882.12.04.245.06.37.06.124 0 .25-.02.369-.06.072-.023 1.787-.6 3.507-1.88C13.743 13.288 15 11.02 15 8.5V3.4c0-.626-.517-1.133-1.154-1.133zM1 8.5h6.5V1c2.364 1.73 3.94 2.308 6.303 2.308.109 0 .197.086.197.192v5H7.5v7.496L7.489 16S1 13.857 1 8.5z" />
  </svg>
);

export const UsersIcon = () => (
  <svg className="icon UsersIcon" width="18" height="18" viewBox="0 0 18 18">
    <path d="M15.585 15.12c3.332-3.574 3.2-9.15-.297-12.561-3.496-3.412-9.08-3.412-12.576 0-3.497 3.411-3.629 8.987-.297 12.56v.03h.03C4.14 16.969 6.514 18 9 18c2.486 0 4.86-1.032 6.555-2.85h.03v-.03zM1.317 9.01c-.003-3.302 2.108-6.235 5.241-7.284 3.134-1.05 6.588.02 8.577 2.657 1.99 2.637 2.068 6.248.196 8.969-.571-1.979-2.032-3.58-3.951-4.329 1.21-1.003 1.66-2.657 1.126-4.134-.534-1.477-1.938-2.462-3.51-2.462-1.573 0-2.976.985-3.51 2.462-.534 1.477-.084 3.13 1.126 4.134-1.92.75-3.38 2.35-3.952 4.329-.878-1.278-1.347-2.792-1.343-4.342zm5.268-2.851c0-1.332 1.081-2.412 2.415-2.412s2.415 1.08 2.415 2.412c0 1.332-1.081 2.412-2.415 2.412-1.333-.002-2.412-1.08-2.415-2.412zm-2.827 8.447C4.028 11.916 6.294 9.87 9 9.87s4.972 2.048 5.242 4.737c-2.944 2.772-7.54 2.772-10.484 0z" />
  </svg>
);
export const Loader = () => (
  <svg className="icon UsersIcon" width="18" height="18" viewBox="0 0 18 18">
    <path d="M15.585 15.12c3.332-3.574 3.2-9.15-.297-12.561-3.496-3.412-9.08-3.412-12.576 0-3.497 3.411-3.629 8.987-.297 12.56v.03h.03C4.14 16.969 6.514 18 9 18c2.486 0 4.86-1.032 6.555-2.85h.03v-.03zM1.317 9.01c-.003-3.302 2.108-6.235 5.241-7.284 3.134-1.05 6.588.02 8.577 2.657 1.99 2.637 2.068 6.248.196 8.969-.571-1.979-2.032-3.58-3.951-4.329 1.21-1.003 1.66-2.657 1.126-4.134-.534-1.477-1.938-2.462-3.51-2.462-1.573 0-2.976.985-3.51 2.462-.534 1.477-.084 3.13 1.126 4.134-1.92.75-3.38 2.35-3.952 4.329-.878-1.278-1.347-2.792-1.343-4.342zm5.268-2.851c0-1.332 1.081-2.412 2.415-2.412s2.415 1.08 2.415 2.412c0 1.332-1.081 2.412-2.415 2.412-1.333-.002-2.412-1.08-2.415-2.412zm-2.827 8.447C4.028 11.916 6.294 9.87 9 9.87s4.972 2.048 5.242 4.737c-2.944 2.772-7.54 2.772-10.484 0z" />
  </svg>
);
export const DownloadIconProgress = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 512 512"
  >
    <path d="M480 352h-133.5l-45.25 45.25C289.2 409.3 273.1 416 256 416s-33.16-6.656-45.25-18.75L165.5 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96C512 366.3 497.7 352 480 352zM432 456c-13.2 0-24-10.8-24-24c0-13.2 10.8-24 24-24s24 10.8 24 24C456 445.2 445.2 456 432 456zM233.4 374.6C239.6 380.9 247.8 384 256 384s16.38-3.125 22.62-9.375l128-128c12.49-12.5 12.49-32.75 0-45.25c-12.5-12.5-32.76-12.5-45.25 0L288 274.8V32c0-17.67-14.33-32-32-32C238.3 0 224 14.33 224 32v242.8L150.6 201.4c-12.49-12.5-32.75-12.5-45.25 0c-12.49 12.5-12.49 32.75 0 45.25L233.4 374.6z" />
  </svg>
);

export const DownLoadSuccess = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 512 512"
  >
    <path d="M128 447.1V223.1c0-17.67-14.33-31.1-32-31.1H32c-17.67 0-32 14.33-32 31.1v223.1c0 17.67 14.33 31.1 32 31.1h64C113.7 479.1 128 465.6 128 447.1zM512 224.1c0-26.5-21.48-47.98-48-47.98h-146.5c22.77-37.91 34.52-80.88 34.52-96.02C352 56.52 333.5 32 302.5 32c-63.13 0-26.36 76.15-108.2 141.6L178 186.6C166.2 196.1 160.2 210 160.1 224c-.0234 .0234 0 0 0 0L160 384c0 15.1 7.113 29.33 19.2 38.39l34.14 25.59C241 468.8 274.7 480 309.3 480H368c26.52 0 48-21.47 48-47.98c0-3.635-.4805-7.143-1.246-10.55C434 415.2 448 397.4 448 376c0-9.148-2.697-17.61-7.139-24.88C463.1 347 480 327.5 480 304.1c0-12.5-4.893-23.78-12.72-32.32C492.2 270.1 512 249.5 512 224.1z" />
  </svg>
);

export const DownloadIcon = () => (
  <svg className="icon DownloadIcon" width="20" height="20" viewBox="0 0 20 20">
    <path
      fillRule="evenodd"
      d="M18.889 13.333c.586 0 1.066.454 1.108 1.029l.003.082v2.223c0 1.799-1.425 3.265-3.208 3.33l-.125.003H3.333c-1.799 0-3.265-1.425-3.33-3.208L0 16.667v-2.223c0-.613.497-1.11 1.111-1.11.586 0 1.066.453 1.108 1.028l.003.082v2.223c0 .585.453 1.065 1.028 1.108l.083.003h13.334c.585 0 1.065-.453 1.108-1.028l.003-.083v-2.223c0-.613.497-1.11 1.11-1.11zM10.7 14.76l-.071.051-.066.04-.085.045-.081.033-.085.028-.034.009-.077.016-.089.012L10 15l-.054-.001-.075-.006-.111-.018-.086-.022-.078-.026-.086-.036-.075-.04-.092-.058-.058-.044-.07-.063L3.658 9.33c-.434-.418-.434-1.097 0-1.515.41-.397 1.064-.417 1.5-.063l.071.063 3.659 3.528V1.072C8.889.48 9.386 0 10 0c.586 0 1.066.437 1.108.991l.003.08v10.27l3.659-3.527c.411-.397 1.064-.417 1.5-.063l.071.063c.411.396.433 1.026.065 1.447l-.065.068-5.555 5.357-.033.03-.01.008.043-.038-.066.059-.02.015z"
    />
  </svg>
);

export const MoreIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="4"
    viewBox="0 0 16 4"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#999" fillRule="nonzero">
        <path
          d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
          transform="translate(-670 -616) translate(108 590) translate(558 16) rotate(90 12 12)"
        />
      </g>
    </g>
  </svg>
);

export const MoreBlueIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0L24 0 24 24 0 24z"
        transform="translate(-1368 -20) translate(1368 20) rotate(90 12 12)"
      />
      <path
        fill="#0036B9"
        fillRule="nonzero"
        d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
        transform="translate(-1368 -20) translate(1368 20) rotate(90 12 12)"
      />
    </g>
  </svg>
);

export const GoBackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="ocnnhzntca" d="M0 0H24V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-108 -20) matrix(-1 0 0 1 132 20)">
        <mask id="k4kirfuo7b" fill="#fff">
          <use xlinkHref="#ocnnhzntca" />
        </mask>
        <g fill="#0036B9" fillRule="nonzero" mask="url(#k4kirfuo7b)">
          <path
            d="M2.12.29L6 4.17 9.88.29c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41L6.7 6.29c-.39.39-1.02.39-1.41 0L.7 1.7C.31 1.31.31.68.7.29c.39-.38 1.03-.39 1.42 0z"
            transform="matrix(0 1 1 0 8.5 6.5)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const ArrowDownIcon = () => (
  <svg
    className="icon ArrowDownIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="6"
    viewBox="0 0 10 6"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g stroke="#0036B9" strokeWidth="2">
        <path
          d="M0 0L4 4 8 0"
          transform="translate(-266 -29) translate(140 12) matrix(-1 0 0 1 135 18)"
        />
      </g>
    </g>
  </svg>
);

export const DownloadBlueIcon = () => (
  <svg
    className="icon downloadBlueIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#0036B9">
        <path
          d="M31.111 20.667c.469 0 .853.362.887.822l.002.067v1.777c0 1.44-1.14 2.613-2.567 2.665l-.1.002H18.667c-1.44 0-2.613-1.14-2.665-2.567l-.002-.1v-1.777c0-.491.398-.89.889-.89.468 0 .852.363.886.823l.003.067v1.777c0 .469.362.853.822.887l.067.002h10.666c.469 0 .853-.362.887-.822l.002-.067v-1.777c0-.491.398-.89.89-.89zM24 10c.469 0 .853.35.886.793l.003.064v8.216l2.927-2.822c.329-.317.851-.334 1.2-.05l.057.05c.329.317.346.82.052 1.158l-.052.054-4.444 4.286-.053.047.026-.024-.041.036-.057.041-.052.032-.069.035-.065.027-.067.022-.028.008-.062.013-.07.01L24 22l-.043-.001-.06-.005-.089-.014-.069-.018-.062-.02-.069-.03-.06-.03-.074-.048-.046-.035-.057-.05-4.444-4.286c-.347-.335-.347-.877 0-1.212.329-.317.851-.334 1.2-.05l.057.05 2.927 2.822v-8.216c0-.473.398-.857.889-.857z"
          transform="translate(-1285 -540) translate(1269 530)"
        />
      </g>
    </g>
  </svg>
);

export const ModalCloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="ohulfw8kra" d="M0 0H24V24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(-1106 -144) translate(310 144) translate(796)">
        <mask id="a94ikhnl0b" fill="#fff">
          <use xlinkHref="#ohulfw8kra" />
        </mask>
        <g
          stroke="#FFF"
          stroke-linecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          mask="url(#a94ikhnl0b)"
        >
          <g>
            <path d="M10 0L0 10M0 0L10 10" transform="translate(7 7)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const FilterCloseIcon = () => (
  <svg
    className="icon filterCloseIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g fill="none" fill-rule="evenodd">
      <path
        d="M0 0L20 0 20 20 0 20z"
        transform="translate(-1380 -18) translate(1156) translate(224 18)"
      />
      <path
        fill="#AAA"
        fill-rule="nonzero"
        d="M15.833 5.342L14.658 4.167 10 8.825 5.342 4.167 4.167 5.342 8.825 10 4.167 14.658 5.342 15.833 10 11.175 14.658 15.833 15.833 14.658 11.175 10z"
        transform="translate(-1380 -18) translate(1156) translate(224 18)"
      />
    </g>
  </svg>
);

export const AddWidgetIcon = () => (
  <svg
    className="icon AddWidgetIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0L16 0 16 16 0 16z"
        transform="translate(-1221 -24) translate(1221 22) translate(0 2)"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M12 13.333H2.667V4h6V2.667h-6c-.734 0-1.334.6-1.334 1.333v9.333c0 .734.6 1.334 1.334 1.334H12c.733 0 1.333-.6 1.333-1.334v-6H12v6zm1.333-10.666v-2H12v2h-2C10.007 2.673 10 4 10 4h2v1.993c.007.007 1.333 0 1.333 0V4h2V2.667h-2z"
        transform="translate(-1221 -24) translate(1221 22) translate(0 2)"
      />
    </g>
  </svg>
);

export const PlusIcon = () => (
  <svg
    className="icon PlusIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0L18 0 18 18 0 18z"
        transform="translate(-1080 -686) translate(310 144) translate(770 542)"
      />
      <path
        fill="#0036B9"
        fillRule="nonzero"
        d="M14.25 9.75L3.75 9.75 3.75 8.25 14.25 8.25z"
        transform="translate(-1080 -686) translate(310 144) translate(770 542)"
      />
      <path
        fill="#0036B9"
        fillRule="nonzero"
        d="M14.25 9.75L3.75 9.75 3.75 8.25 14.25 8.25z"
        transform="translate(-1080 -686) translate(310 144) translate(770 542) rotate(90 9 9)"
      />
    </g>
  </svg>
);

export const DeleteIcon = () => (
  <svg
    className="icon DeleteIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="19"
    viewBox="0 0 16 19"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#0036B9" fill-rule="nonzero">
        <path
          d="M8.47 0c.935 0 1.695.76 1.695 1.694v.565h3.106c.778 0 1.411.633 1.411 1.412v1.976c0 .312-.252.565-.564.565h-.309l-.488 10.245c-.043.905-.786 1.614-1.692 1.614H3.053c-.905 0-1.649-.71-1.692-1.614L.873 6.212H.565C.253 6.212 0 5.959 0 5.647V3.671c0-.779.633-1.412 1.412-1.412h3.106v-.565C4.518.76 5.278 0 6.212 0zm4.208 6.212H2.004l.485 10.191c.015.302.262.538.564.538h8.576c.302 0 .55-.236.564-.538l.485-10.191zm-5.337 1.13c.312 0 .565.252.565.564v7.341c0 .312-.253.565-.565.565-.312 0-.565-.253-.565-.565V7.906c0-.312.253-.565.565-.565zm2.824 0c.312 0 .564.252.564.564v7.341c0 .312-.252.565-.564.565-.312 0-.565-.253-.565-.565V7.906c0-.312.253-.565.565-.565zm-5.647 0c.312 0 .564.252.564.564v7.341c0 .312-.252.565-.564.565-.312 0-.565-.253-.565-.565V7.906c0-.312.253-.565.565-.565zm8.753-3.954H1.41c-.155 0-.282.127-.282.283v1.411h12.424V3.671c0-.156-.127-.283-.282-.283zM8.47 1.13H6.21c-.31 0-.564.254-.564.565v.565h3.388v-.565c0-.311-.253-.565-.564-.565z"
          transform="translate(-1328 -208) translate(108 130) translate(1176 20) translate(0 58) translate(44) translate(.47)"
        />
      </g>
    </g>
  </svg>
);

export const EditIcon = () => (
  <svg
    className="icon EditIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#FFF" stroke="#0035B8" stroke-width="1.5">
        <path
          d="M13.208.939c.253-.068.523-.07.784 0 .26.07.493.207.678.391.184.185.321.417.391.678.07.261.068.531 0 .784-.067.252-.2.487-.391.678h0L4.01 14.129l-2.941.802.802-2.942L12.531 1.33c.19-.19.425-.324.677-.391z"
          transform="translate(-1284 -209) translate(108 130) translate(1176 20) translate(0 58) translate(0 1)"
        />
      </g>
    </g>
  </svg>
);

export const FacebookIcon = ({cla}) => (
  <svg className={"icon FacebookIcon "+(cla?cla:"")} width="15" height="15" viewBox="0 0 15 15">
    <g fill="none" fillRule="evenodd">
      <circle cx="7.5" cy="7.5" r="7.5" fill="#4267B2" />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M9.898 15V9.534h1.776l.266-2.14H9.898V6.032c0-.618.165-1.04 1.02-1.04H12V3.085C11.812 3.058 11.166 3 10.414 3c-1.57 0-2.645.994-2.645 2.82v1.574H6v2.14h1.77V15h2.128z"
      />
    </g>
  </svg>
);

export const CloseIcon = () => (
  <svg className="icon CloseIcon" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fillRule="evenodd">
      <path className="pathOne" d="M0 0L20 0 20 20 0 20z" />
      <path
        className="pathTwo"
        fill="#AAA"
        fillRule="nonzero"
        d="M15.833 5.342L14.658 4.167 10 8.825 5.342 4.167 4.167 5.342 8.825 10 4.167 14.658 5.342 15.833 10 11.175 14.658 15.833 15.833 14.658 11.175 10z"
      />
    </g>
  </svg>
);

export const CalendarIcon = () => (
  <svg className="icon CalendarIcon" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L18 0 18 18 0 18z" />
      <path
        fill="#AAA"
        fillRule="nonzero"
        d="M15 2.25h-.75V.75h-1.5v1.5h-7.5V.75h-1.5v1.5H3c-.825 0-1.5.675-1.5 1.5v12c0 .825.675 1.5 1.5 1.5h12c.825 0 1.5-.675 1.5-1.5v-12c0-.825-.675-1.5-1.5-1.5zm0 13.5H3V6h12v9.75z"
      />
    </g>
  </svg>
);

export const AddIcon = () => (
  <svg className="icon AddIcon" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L18 0 18 18 0 18z" />
      <path
        fill="#0067DC"
        fillRule="nonzero"
        d="M14.25 9.75L9.75 9.75 9.75 14.25 8.25 14.25 8.25 9.75 3.75 9.75 3.75 8.25 8.25 8.25 8.25 3.75 9.75 3.75 9.75 8.25 14.25 8.25z"
      />
    </g>
  </svg>
);

export const RemoveIcon = () => (
  <svg className="icon RemoveIcon" width="18" height="18" viewBox="0 0 18 18">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0L18 0 18 18 0 18z" />
      <path
        fill="#0067DC"
        fillRule="nonzero"
        d="M14.25 9.75L3.75 9.75 3.75 8.25 14.25 8.25z"
      />
    </g>
  </svg>
);

export const LinkIcon = () => (
  <svg
    className="icon LinkIcon"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Product-Details---accordion-V01"
        transform="translate(-1022.000000, -1680.000000)"
        fill="#0036B9"
        fill-rule="nonzero"
      >
        <path
          d="M1032.823,1681.883 C1032.303,1681.883 1031.882,1681.461 1031.882,1680.941 C1031.882,1680.421 1032.304,1680 1032.823,1680 L1037.059,1680 C1037.579,1680 1038,1680.422 1038,1680.941 L1038,1685.177 C1038,1685.697 1037.578,1686.118 1037.059,1686.118 C1036.539,1686.118 1036.118,1685.696 1036.118,1685.177 L1036.118,1683.213 L1030.665,1688.665 C1030.298,1689.033 1029.702,1689.033 1029.335,1688.665 C1028.967,1688.298 1028.967,1687.702 1029.335,1687.335 L1034.787,1681.883 L1032.823,1681.883 L1032.823,1681.883 Z M1036.118,1688.941 C1036.118,1688.421 1036.539,1688.001 1037.058,1688.001 C1037.578,1688.001 1038,1688.421 1038,1688.941 L1038,1695.059 C1038,1695.579 1037.578,1696 1037.059,1696 L1022.94,1696 C1022.42,1696 1021.999,1695.578 1021.999,1695.059 L1021.999,1680.94 C1021.999,1680.42 1022.421,1679.999 1022.94,1679.999 L1029.058,1679.999 C1029.578,1679.999 1029.999,1680.421 1029.999,1680.94 C1029.999,1681.46 1029.578,1681.882 1029.058,1681.882 L1023.883,1681.882 L1023.883,1694.117 L1036.118,1694.117 L1036.118,1688.94 L1036.118,1688.941 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const InstagramIcon = ({cla}) => {
  const instaID = Math.random();
  return (
    <svg
      className={"icon InstagramIcon "+(cla?cla:"")}
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
    >
      <defs>
        <linearGradient
          id={instaID}
          x1="6.714%"
          x2="93.608%"
          y1="93.485%"
          y2="6.619%"
        >
          <stop offset="0%" stop-color="#FD5" />
          <stop offset="50%" stop-color="#FF543E" />
          <stop offset="100%" stop-color="#C837AB" />
        </linearGradient>
      </defs>
      <g fill="none">
        <circle cx="7.5" cy="7.5" r="7.5" fill={`url(#${instaID})`} />
        <path
          fill="#FFF"
          d="M7.5 3.004c-1.843 0-3.593-.163-4.262 1.55-.276.709-.236 1.629-.236 2.945 0 1.156-.037 2.242.236 2.944.667 1.716 2.432 1.551 4.261 1.551 1.765 0 3.585.184 4.262-1.55.276-.716.236-1.622.236-2.945 0-1.756.097-2.89-.756-3.74-.863-.863-2.03-.755-3.743-.755H7.5zm-.403.81c3.845-.006 4.334-.433 4.064 5.5-.096 2.099-1.695 1.868-3.66 1.868-3.584 0-3.687-.102-3.687-3.685 0-3.624.284-3.68 3.283-3.684v.001zm2.804.747c-.298 0-.54.24-.54.539 0 .297.242.539.54.539.298 0 .54-.242.54-.54 0-.297-.242-.538-.54-.538zm-2.4.63c-1.277 0-2.31 1.034-2.31 2.308 0 1.275 1.033 2.308 2.31 2.308 1.275 0 2.308-1.033 2.308-2.308 0-1.274-1.033-2.308-2.309-2.308zm0 .81c1.981 0 1.984 2.997 0 2.997C5.517 8.998 5.514 6 7.5 6z"
        />
      </g>
    </svg>
  );
};

export const LinkedInIcon = ({cla}) => {
  return (
    <svg className={cla?cla:""}
    xmlns="http://www.w3.org/2000/svg" 
    // xmlns:xlink="http://www.w3.org/1999/xlink" 
    width="15" height="15" viewBox="0 0 15 15">
      <g id="LInked_in_Whitebg" transform="translate(-613 -324)">
        <rect id="Rectangle_1" data-name="Rectangle 1" width="15" height="15" rx="2" transform="translate(613 324)" fill="#fff"/>
        <image id="images_1_" data-name="images (1)" width="10" height="10" transform="translate(616 327)" href="data:image/png;base64,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"/>
      </g>
    </svg>
  );
};

export const FacebookWBIcon = ({cla}) => {
  return (
    <svg className={cla?cla:""} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <g id="Facebook_white" transform="translate(-706 -465)">
        <rect id="Rectangle_3" data-name="Rectangle 3" width="15" height="15" rx="2" transform="translate(706 465)" fill="#fff"/>
        <path id="Path_12" data-name="Path 12" d="M393.646,350.088v-4.879H392v-1.94h1.646v-1.675s.118-3.145,4.145-2.263v1.734h-1.176a.865.865,0,0,0-.852.941v1.264h1.881l-.235,1.94h-1.646v4.879Z" transform="translate(318.605 127.869)" fill="#0077b5"/>
      </g>
    </svg>
  );
};

export const InstagramWBIcon = ({cla}) => {
  return (
    <svg className={cla?cla:""} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <g id="Insta_white_black" transform="translate(-714 -462)">
        <rect id="Rectangle_3" data-name="Rectangle 3" width="15" height="15" rx="2" transform="translate(714 462)" fill="#fff"/>
        <g id="Rectangle_11" data-name="Rectangle 11" transform="translate(716 464)" fill="none" stroke="#0077b5" stroke-width="1">
          <rect width="11" height="11" rx="2" stroke="none"/>
          <rect x="0.5" y="0.5" width="10" height="10" rx="1.5" fill="none"/>
        </g>
        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(718 466)" fill="#fff" stroke="#0077b5" stroke-width="1">
          <circle cx="3.5" cy="3.5" r="3.5" stroke="none"/>
          <circle cx="3.5" cy="3.5" r="3" fill="none"/>
        </g>
        <circle id="Ellipse_2" data-name="Ellipse 2" cx="0.5" cy="0.5" r="0.5" transform="translate(724 466)" fill="#0077b5"/>
      </g>
    </svg>
  );
};

export const TwitterWBIcon = ({cla}) => {
  return (
    <svg className={cla?cla:""} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
      <g id="Twitter_white_black" transform="translate(-714 -462)">
        <rect id="Rectangle_3" data-name="Rectangle 3" width="15" height="15" rx="2" transform="translate(714 462)" fill="#fff"/>
        <g id="logo-x-twitter" transform="translate(716.177 464.491)">
          <path id="Path_13" data-name="Path 13" d="M.222-458.175c0,.006.343.48.77,1.051l2.016,2.7,1.24,1.658-.079.09-2.025,2.188C1.076-449.336.2-448.383.2-448.373a2.326,2.326,0,0,0,.45.017l.457,0,.15-.165,1.727-1.866c.867-.937,1.6-1.731,1.63-1.765l.054-.062.429.575,1.444,1.933,1.017,1.356H9.109a10.165,10.165,0,0,0,1.544-.028c-.006-.017-.4-.549-.877-1.186s-1.021-1.364-1.21-1.617-.751-1.006-1.248-1.669-.905-1.218-.905-1.227,2.63-2.87,3.524-3.824l.255-.272h-.47l-.468,0-.547.592c-.3.326-1.036,1.124-1.637,1.77l-1.088,1.175L4.665-456.4l-1.321-1.765-1.555-.011C.932-458.184.227-458.182.222-458.175Zm3.685,1.9c.508.682,1.293,1.731,1.744,2.334S7.1-452,7.874-450.97l1.422,1.9a2.516,2.516,0,0,1-.695.026h-.71l-1.407-1.883q-4.871-6.509-4.906-6.564c-.013-.019.133-.026.693-.026h.71Z" transform="translate(-0.197 458.181)"/>
        </g>
      </g>
    </svg>
  );
};

export const NoFeedIcon = ({ size }) => {
  let height = 70;
  let width = 65;
  if (size == "sm") {
    height = 50;
  }
  return (
    <svg
      className="icon NoFeedIcon"
      xmlns="http://www.w3.org/2000/svg"
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 65 70"
    >
      <g fill="none">
        <path
          fill="#0036b9"
          d="M8.75 19.688c0-7.64 6.215-13.855 13.854-13.855h26.638C48.282 2.476 45.222 0 41.562 0H8.022C3.596 0 0 3.596 0 8.02v45.21c0 4.424 3.596 8.02 8.02 8.02h.73V19.687z"
        />
        <path
          fill="#AAA"
          d="M56.146 11.667H22.604c-4.424 0-8.02 3.596-8.02 8.02V61.98c0 4.425 3.596 8.021 8.02 8.021h33.542c4.424 0 8.02-3.596 8.02-8.02V19.687c0-4.425-3.596-8.021-8.02-8.021zM50.312 61.25H28.439c-1.208 0-2.188-.98-2.188-2.188 0-1.207.98-2.187 2.188-2.187h21.875c1.207 0 2.187.98 2.187 2.188 0 1.207-.98 2.187-2.188 2.187zm0-11.667H28.439c-1.208 0-2.188-.98-2.188-2.187 0-1.208.98-2.188 2.188-2.188h21.875c1.207 0 2.187.98 2.187 2.188 0 1.207-.98 2.187-2.188 2.187zm0-10.208H28.439c-1.208 0-2.188-.98-2.188-2.188 0-1.207.98-2.187 2.188-2.187h21.875c1.207 0 2.187.98 2.187 2.188 0 1.207-.98 2.187-2.188 2.187zm0-11.667H28.439c-1.208 0-2.188-.98-2.188-2.187 0-1.208.98-2.188 2.188-2.188h21.875c1.207 0 2.187.98 2.187 2.188 0 1.207-.98 2.187-2.188 2.187z"
        />
      </g>
    </svg>
  );
};

export const WidgetBuildingIcon = () => (
  <svg
    className="icon WidgetBuildingIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="80"
    height="80"
    viewBox="0 0 80 80"
  >
    <g fill="none">
      <path
        fill="#AAA"
        d="M36.201 2.579c0-.762-.337-1.485-.921-1.975-.584-.49-1.356-.698-2.106-.565-6.332 1.126-12.15 3.732-17.089 7.447-.596.448-.969 1.134-1.02 1.88-.053.744.222 1.474.75 2.002l13.299 13.3c.813.813 2.068.99 3.073.43.743-.412 1.52-.77 2.328-1.068 1.014-.373 1.686-1.338 1.686-2.418V2.579z"
      />
      <path
        fill="#E30E13"
        d="M44.337 21.612c0 1.08.674 2.045 1.688 2.418 4.58 1.684 8.215 5.32 9.9 9.9.372 1.014 1.338 1.687 2.418 1.687h19.035c.763 0 1.486-.338 1.975-.923.49-.585.695-1.356.561-2.107C76.971 16.037 63.918 2.983 47.367.04c-.75-.134-1.52.072-2.105.561-.585.49-.925 1.213-.925 1.975v19.036z"
      />
      <path
        fill="#666"
        d="M58.343 43.753c-1.08 0-2.046.674-2.419 1.688-2.344 6.374-8.467 10.921-15.655 10.921-9.21 0-16.677-7.467-16.677-16.677 0-2.057.374-4.025 1.055-5.844.354-.946.123-2.012-.592-2.727L10.4 17.458c-.55-.55-1.32-.822-2.094-.74-.775.082-1.472.51-1.894 1.163C2.355 24.165 0 31.65 0 39.685c0 22.24 18.03 40.27 40.27 40.27 19.817 0 36.291-14.317 39.644-33.172.134-.75-.072-1.52-.561-2.105-.49-.585-1.213-.925-1.975-.925H58.343z"
      />
    </g>
  </svg>
);

export const ListningIcon = () => (
  <svg
    className="icon ListningIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="20"
    viewBox="0 0 23 20"
  >
    <path d="M21.862 6.738L19.618 5.59V2.001c0-1.526-1.61-2.485-2.903-1.747C14.19 1.695 11.3 2.99 8.356 4H1.953c-1.077 0-1.953.897-1.953 2v4c0 .9.584 1.663 1.385 1.913l1.022 6.475.005.024c.18.92.974 1.587 1.89 1.587 1.21 0 2.122-1.13 1.893-2.347L5.7 14.455c1.047-.402 1.822-1.336 2.046-2.454h.61c2.984 1.024 5.796 2.285 8.36 3.747 1.291.738 2.902-.22 2.902-1.748v-3.587l2.244-1.15c.22-.112.36-.343.36-.595V7.334c0-.252-.14-.483-.36-.596zM4.302 18.667c-.294 0-.55-.212-.612-.505L2.718 12H4l.91 5.873.005.026c.077.397-.219.767-.614.767zm1.187-5.576l-.17-1.095H6.4c-.162.465-.487.86-.91 1.095zm2.324-2.424h-5.86c-.359 0-.65-.299-.65-.666V6c0-.367.291-.667.65-.667h5.86v5.333zM18.316 14c0 .512-.54.827-.967.584-2.534-1.446-5.302-2.7-8.234-3.728v-5.71c2.9-1.019 5.737-2.303 8.234-3.728.427-.243.967.071.967.583v12zm2.604-5.744l-1.302.666V7.08l1.302.666v.51z" />
  </svg>
);

export const VideoPlayIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon VideoPlayIcon"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M10.8 15.9l4.67-3.5c.27-.2.27-.6 0-.8L10.8 8.1c-.33-.25-.8-.01-.8.4v7c0 .41.47.65.8.4zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
  </svg>
);

export const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon BackArrow"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" />
  </svg>
);

export const ForwardArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="icon ForwardArrow"
    height="24"
    viewBox="0 0 24 24"
    width="24"
  >
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </svg>
);

export const BackBtnArrow = () => (
  <svg
    className="icon BackBtnArrow"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-105 -727) translate(105 44) translate(0 683) matrix(-1 0 0 1 32 0)"
      />
      <path
        fill="#000"
        d="M13.41 10L12 11.41 16.58 16 12 20.59 13.41 22 19.41 16z"
        transform="translate(-105 -727) translate(105 44) translate(0 683) matrix(-1 0 0 1 32 0)"
      />
    </g>
  </svg>
);

export const ForwardBtnArrow = () => (
  <svg
    className="icon ForwardBtnArrow"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0H32V32H0z"
        transform="translate(-1359 -727) translate(105 44) translate(1254 683)"
      />
      <path
        fill="#000"
        d="M13.41 10L12 11.41 16.58 16 12 20.59 13.41 22 19.41 16z"
        transform="translate(-1359 -727) translate(105 44) translate(1254 683)"
      />
    </g>
  </svg>
);

export const FavoriteIcon = () => (
  <svg
    className="icon favoriteIcon"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Product-Details---accordion-V01"
        transform="translate(-1032.000000, -1708.000000)"
        fill="#0036B9"
        fill-rule="nonzero"
      >
        <path
          d="M1047.15,1713.355 L1042.625,1712.945 L1040.859,1708.594 C1040.541,1707.802 1039.456,1707.802 1039.139,1708.594 L1037.372,1712.954 L1032.857,1713.355 C1032.035,1713.424 1031.698,1714.499 1032.324,1715.065 L1035.754,1718.175 L1034.727,1722.789 C1034.54,1723.63 1035.409,1724.295 1036.119,1723.845 L1040.00001,1721.401 L1043.879,1723.855 C1044.589,1724.305 1045.459,1723.64 1045.272,1722.799 L1044.243,1718.175 L1047.673,1715.065 C1048.3,1714.499 1047.973,1713.424 1047.15,1713.355 Z M1039.999,1719.573 L1036.484,1721.793 L1037.419,1717.608 L1034.315,1714.792 L1038.41,1714.421 L1039.999,1710.481 L1041.597,1714.431 L1045.691,1714.802 L1042.588,1717.618 L1043.523,1721.802 L1039.999,1719.572 L1039.999,1719.573 Z"
          id="Shape"
        ></path>
      </g>
    </g>
  </svg>
);

export const FavoriteFilledIcon = () => (
  <svg
    className="icon favoriteFilledIcon"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Product-Details---accordion-V01"
        transform="translate(-966.000000, -1675.000000)"
        fill="#FFD100"
        fill-rule="nonzero"
      >
        <path
          d="M981.15,1680.355 L976.625,1679.945 L974.859,1675.594 C974.541,1674.802 973.456,1674.802 973.139,1675.594 L971.372,1679.954 L966.857,1680.355 C966.035,1680.424 965.698,1681.499 966.324,1682.065 L969.754,1685.175 L968.727,1689.789 C968.54,1690.63 969.409,1691.295 970.119,1690.845 L974.000005,1688.401 L977.879,1690.855 C978.589,1691.305 979.459,1690.64 979.272,1689.799 L978.243,1685.175 L981.673,1682.065 C982.3,1681.499 981.973,1680.424 981.15,1680.355 Z"
          id="Path"
        ></path>
      </g>
    </g>
  </svg>
);

export const FilterIcon = () => (
  <svg
    className="icon filterIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <path
          d="M19.706 0H4.294C1.926 0 0 1.926 0 4.294v15.412C0 22.074 1.926 24 4.294 24h15.412C22.074 24 24 22.074 24 19.706V4.294C24 1.926 22.074 0 19.706 0zm2.888 19.706c0 1.593-1.296 2.888-2.888 2.888H4.294c-1.592 0-2.888-1.296-2.888-2.888V4.294c0-1.592 1.295-2.888 2.888-2.888h15.412c1.593 0 2.888 1.295 2.888 2.888v15.412z"
          transform="translate(-1315 -80) translate(1299 74) translate(16 6)"
        />
        <path
          fill="#0036B9"
          d="M20.284 5.272H9.575c-.294-.875-1.121-1.506-2.094-1.506-.972 0-1.8.631-2.094 1.506H3.716c-.389 0-.703.315-.703.703 0 .388.314.703.703.703h1.671c.295.875 1.122 1.506 2.094 1.506.973 0 1.8-.631 2.094-1.506h10.71c.388 0 .703-.315.703-.703 0-.388-.315-.703-.704-.703zM7.481 6.778c-.443 0-.803-.36-.803-.803 0-.443.36-.803.803-.803.443 0 .803.36.803.803 0 .443-.36.803-.803.803zM20.284 11.297h-1.671c-.295-.875-1.122-1.506-2.094-1.506-.973 0-1.8.631-2.094 1.506H3.715c-.388 0-.702.315-.702.703 0 .388.314.703.703.703h10.709c.294.875 1.121 1.506 2.094 1.506.972 0 1.8-.631 2.094-1.506h1.671c.389 0 .704-.315.704-.703 0-.388-.315-.703-.704-.703zm-3.765 1.506c-.443 0-.803-.36-.803-.803 0-.443.36-.803.803-.803.443 0 .803.36.803.803 0 .443-.36.803-.803.803zM20.284 17.322h-7.696c-.295-.875-1.122-1.506-2.094-1.506-.973 0-1.8.631-2.094 1.506H3.716c-.389 0-.703.315-.703.703 0 .388.314.703.703.703H8.4c.294.875 1.121 1.506 2.094 1.506.972 0 1.8-.631 2.094-1.506h7.696c.389 0 .704-.315.704-.703 0-.388-.315-.703-.704-.703zm-9.79 1.506c-.443 0-.803-.36-.803-.803 0-.443.36-.803.803-.803.443 0 .803.36.803.803 0 .443-.36.803-.803.803z"
          transform="translate(-1315 -80) translate(1299 74) translate(16 6)"
        />
      </g>
    </g>
  </svg>
);

export const FemaleIcon = ({ fillValue, fillColor }) => {
  return (
    <svg
      width="75.293"
      height="210.241"
      viewBox="0 0 75.293 210.241"
      className="item-chart-path female-chart-path"
    >
      <defs>
        <clipPath id="female">
          <circle
            cx="20.168"
            cy="20.168"
            r="20.168"
            transform="translate(17.865)"
          ></circle>
          <path
            d="M50.279,178.03h-13.9a9.857,9.857,0,0,1-9.856-9.856v-65.2H11.645A6.356,6.356,0,0,1,5.3,96.626L22.381,20.445a6.358,6.358,0,0,1,6.357-6.35h1.041a20.1,20.1,0,0,0,13.548,5.227,20.1,20.1,0,0,0,13.548-5.227h.641a6.361,6.361,0,0,1,6.35,6.35L80.591,96.622a6.356,6.356,0,0,1-6.35,6.347H60.131v65.2A9.858,9.858,0,0,1,50.279,178.03Z"
            transform="translate(-5.298 32.212)"
          ></path>
        </clipPath>
      </defs>
      <rect
        x="0"
        y="0"
        fill="#cfd8dc"
        width="100%"
        height="100%"
        clipPath="url(#female)"
      ></rect>
      <rect
        x="0"
        y={`${fillValue}%`}
        fill={`${fillColor}`}
        width="100%"
        height="100%"
        className="item-chart-rect"
        clipPath="url(#female)"
      >
        <animate
          attributeName="y"
          from="100%"
          to={`${fillValue}%`}
          dur="1500ms"
          fill="freeze"
        ></animate>
      </rect>
      <rect
        x="0"
        y={`${fillValue}%`}
        fill="#eb5888"
        width="100%"
        height="100%"
        className="item-chart-rect item-chart-rect-tohide"
        clipPath="url(#female)"
      >
        <animate
          attributeName="y"
          from="100%"
          to={`${fillValue}%`}
          dur="1500ms"
          fill="freeze"
        ></animate>
      </rect>
    </svg>
  );
};

FemaleIcon.defaultProps = {
  fillValue: 0,
  fillColor: "#cfd8dc",
};

FemaleIcon.propTypes = {
  fillValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fillColor: PropTypes.string,
};

export const MaleIcon = ({ fillValue, fillColor }) => {
  return (
    <svg
      width="75.293"
      height="210.244"
      viewBox="0 0 67.596 210.244"
      className="item-chart-path male-chart-path"
    >
      <defs>
        <clipPath id="male">
          <circle
            cx="20.168"
            cy="20.168"
            r="20.168"
            transform="translate(13.537)"
          ></circle>
          <path
            d="M81.706,178.031H61.085a9.857,9.857,0,0,1-9.856-9.856v-65.2H47.639a9.857,9.857,0,0,1-9.856-9.856V23.952A9.857,9.857,0,0,1,47.639,14.1H58.22a20.1,20.1,0,0,0,13.548,5.227A20.1,20.1,0,0,0,85.317,14.1H95.524a9.857,9.857,0,0,1,9.856,9.856v69.17a9.857,9.857,0,0,1-9.856,9.856H91.562v65.2a9.857,9.857,0,0,1-9.856,9.856Z"
            transform="translate(-37.738 32.213)"
          ></path>
        </clipPath>
      </defs>
      <rect
        x="0"
        y="0"
        fill="#cfd8dc"
        width="100%"
        height="100%"
        clipPath="url(#male)"
      ></rect>
      <rect
        x="0"
        y={`${fillValue}%`}
        fill={`${fillColor}`}
        width="100%"
        height="100%"
        className="item-chart-rect"
        clipPath="url(#male)"
      >
        <animate
          attributeName="y"
          from="100%"
          to={`${fillValue}%`}
          dur="1500ms"
          fill="freeze"
        ></animate>
      </rect>
      <rect
        x="0"
        y={`${fillValue}%`}
        fill="#63a4ff"
        width="100%"
        height="100%"
        className="item-chart-rect item-chart-rect-tohide"
        clipPath="url(#male)"
      >
        <animate
          attributeName="y"
          from="100%"
          to={`${fillValue}%`}
          dur="1500ms"
          fill="freeze"
        ></animate>
      </rect>
    </svg>
  );
};

export const AnalysisIcon = () => {
  return (
    <svg
      className="icon analysisIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="12"
      viewBox="0 0 14 12"
    >
      <g fill-rule="evenodd">
        <path
          d="M3 4c.367 0 .667.3.667.667v6.666c0 .367-.3.667-.667.667H.667C.3 12 0 11.7 0 11.333V4.667C0 4.3.3 4 .667 4H3zm-.636 1H1.303C1.136 5 1 5.125 1 5.278v5.203c0 .153.136.278.303.278h1.06c.167 0 .304-.125.304-.278V5.278c0-.153-.137-.278-.303-.278zM8 0c.367 0 .667.3.667.667v10.666c0 .367-.3.667-.667.667H5.667C5.3 12 5 11.7 5 11.333V.667C5 .3 5.3 0 5.667 0zm-.636 1H6.303C6.136 1 6 1.25 6 1.556v8.888c0 .306.136.556.303.556h1.06c.167 0 .304-.25.304-.556V1.556C7.667 1.25 7.53 1 7.364 1zM13 5.333c.367 0 .667.3.667.667v5.333c0 .367-.3.667-.667.667h-2.333c-.367 0-.667-.3-.667-.667V6c0-.367.3-.667.667-.667zm-.636.908h-1.061c-.167 0-.303.125-.303.278v4.203c0 .153.136.278.303.278h1.06c.167 0 .304-.125.304-.278V6.52c0-.153-.137-.278-.303-.278z"
          transform="translate(-281 -590) translate(280 588) translate(1 2)"
        />
      </g>
    </svg>
  );
};

export const StockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 23 21" fill="none">
<path d="M22.1915 18.1535H21.5947V4.89884C21.5947 4.69867 21.4321 4.53516 21.231 4.53516H17.4457C17.2455 4.53516 17.082 4.69774 17.082 4.89884V18.1535H16.2212V10.299C16.2212 10.0988 16.0586 9.93527 15.8575 9.93527H12.0722C11.872 9.93527 11.7085 10.0978 11.7085 10.299V18.1535H10.8486L10.8476 8.0038C10.8476 7.80363 10.6851 7.64011 10.4839 7.64011H6.69863C6.49846 7.64011 6.33494 7.80269 6.33494 8.0038V18.1535H5.47411V13.4123C5.47411 13.2122 5.31153 13.0486 5.11042 13.0486H1.32414C1.12397 13.0486 0.960452 13.2112 0.960452 13.4123V18.1535H0.363688C0.163517 18.1535 0 18.3161 0 18.5172V20.0058C0 20.2059 0.162581 20.3695 0.363688 20.3695H22.191C22.3912 20.3695 22.5547 20.2069 22.5547 20.0058V18.5172C22.5556 18.317 22.393 18.1535 22.1919 18.1535H22.1915ZM17.8092 5.26357H20.8683V18.1535H17.8092V5.26357ZM12.4346 10.6634H15.4936V18.1535H12.4346V10.6634ZM7.06196 8.36662H10.121V18.1535H7.06196V8.36662ZM1.68831 13.7759H4.74731V18.1533H1.68831V13.7759ZM21.8277 19.642H0.727907V18.8808H21.8267L21.8277 19.642Z" fill="white"/>
<path d="M7.23507 4.47139L4.12627 6.8801C3.87534 6.68369 3.56051 6.56621 3.21845 6.56621C2.40274 6.56621 1.73926 7.22969 1.73926 8.04541C1.73926 8.86019 2.40274 9.5246 3.21845 9.5246C4.03323 9.5246 4.69577 8.86113 4.69577 8.04541C4.69577 7.83584 4.6516 7.63567 4.57266 7.45524L7.68147 5.04556C7.93239 5.24198 8.24816 5.35945 8.59116 5.35945C9.05916 5.35945 9.47736 5.14048 9.74802 4.79935L12.5092 6.0389C12.4941 6.1216 12.4866 6.20806 12.4866 6.29452C12.4866 7.1093 13.1501 7.77184 13.9658 7.77184C14.7815 7.77184 15.445 7.1093 15.445 6.29452C15.445 6.04643 15.383 5.81336 15.2759 5.60848L18.5163 2.70465C18.7512 2.86347 19.035 2.95652 19.3395 2.95652C20.1552 2.95652 20.8187 2.29304 20.8187 1.47732C20.8187 0.662539 20.1552 0 19.3395 0C18.5247 0 17.8622 0.662539 17.8622 1.47732C17.8622 1.72447 17.9233 1.95755 18.0314 2.16336L14.7909 5.06719C14.556 4.90931 14.2722 4.81533 13.9677 4.81533C13.4997 4.81533 13.0815 5.03429 12.8108 5.37543L10.0497 4.13587C10.0647 4.05317 10.0722 3.96672 10.0722 3.88026C10.0722 3.06548 9.40875 2.40294 8.59303 2.40294C7.77731 2.40294 7.11384 3.06548 7.11384 3.88026C7.1129 4.09076 7.15613 4.29095 7.23507 4.47139ZM19.3376 0.727449C19.752 0.727449 20.0894 1.06388 20.0894 1.47739C20.0894 1.89184 19.753 2.22921 19.3376 2.22921C18.924 2.22921 18.5876 1.89278 18.5876 1.47739C18.5876 1.06484 18.924 0.727449 19.3376 0.727449ZM13.9658 5.54391C14.3803 5.54391 14.7177 5.88034 14.7177 6.29573C14.7177 6.70924 14.3812 7.04567 13.9658 7.04567C13.5514 7.04567 13.214 6.70924 13.214 6.29573C13.214 5.88127 13.5505 5.54391 13.9658 5.54391ZM3.21855 8.79658C2.8041 8.79658 2.46673 8.46015 2.46673 8.04476C2.46673 7.63031 2.80316 7.29294 3.21855 7.29294C3.63206 7.29294 3.96849 7.62937 3.96849 8.04476C3.96849 8.46015 3.63206 8.79658 3.21855 8.79658ZM8.59123 3.13159C9.00568 3.13159 9.34305 3.46802 9.34305 3.88153C9.34305 4.29598 9.00662 4.63335 8.59123 4.63335C8.17678 4.63335 7.83941 4.29692 7.83941 3.88153C7.83941 3.46802 8.17678 3.13159 8.59123 3.13159Z" fill="white"/>
</svg>
  );
};

export const StockBlueIcon = ({color = ''}) => {
  return (
    <svg class="icon analysisIcon" xmlns="http://www.w3.org/2000/svg" width="14" height="12" viewBox="0 0 23 21" >
<path d="M22.6368 18.1535H22.04V4.89884C22.04 4.69867 21.8774 4.53516 21.6763 4.53516H17.891C17.6908 4.53516 17.5273 4.69774 17.5273 4.89884V18.1535H16.6665V10.299C16.6665 10.0988 16.5039 9.93527 16.3028 9.93527H12.5175C12.3173 9.93527 12.1538 10.0978 12.1538 10.299V18.1535H11.2939L11.2929 8.0038C11.2929 7.80363 11.1304 7.64011 10.9293 7.64011H7.14394C6.94377 7.64011 6.78025 7.80269 6.78025 8.0038V18.1535H5.91942V13.4123C5.91942 13.2122 5.75684 13.0486 5.55574 13.0486H1.76945C1.56928 13.0486 1.40576 13.2112 1.40576 13.4123V18.1535H0.809001C0.608829 18.1535 0.445312 18.3161 0.445312 18.5172V20.0058C0.445312 20.2059 0.607893 20.3695 0.809001 20.3695H22.6363C22.8365 20.3695 23 20.2069 23 20.0058V18.5172C23.0009 18.317 22.8384 18.1535 22.6372 18.1535H22.6368ZM18.2546 5.26357H21.3136V18.1535H18.2546V5.26357ZM12.88 10.6634H15.939V18.1535H12.88V10.6634ZM7.50727 8.36662H10.5663V18.1535H7.50727V8.36662ZM2.13362 13.7759H5.19263V18.1533H2.13362V13.7759ZM22.273 19.642H1.17322V18.8808H22.272L22.273 19.642Z" fill={color}/>
<path d="M7.68038 4.47139L4.57158 6.8801C4.32065 6.68369 4.00583 6.56621 3.66377 6.56621C2.84805 6.56621 2.18457 7.22969 2.18457 8.04541C2.18457 8.86019 2.84805 9.5246 3.66377 9.5246C4.47855 9.5246 5.14109 8.86113 5.14109 8.04541C5.14109 7.83584 5.09692 7.63567 5.01797 7.45524L8.12678 5.04556C8.37771 5.24198 8.69347 5.35945 9.03647 5.35945C9.50447 5.35945 9.92268 5.14048 10.1933 4.79935L12.9545 6.0389C12.9395 6.1216 12.9319 6.20806 12.9319 6.29452C12.9319 7.1093 13.5954 7.77184 14.4111 7.77184C15.2269 7.77184 15.8903 7.1093 15.8903 6.29452C15.8903 6.04643 15.8283 5.81336 15.7212 5.60848L18.9616 2.70465C19.1965 2.86347 19.4803 2.95652 19.7848 2.95652C20.6005 2.95652 21.264 2.29304 21.264 1.47732C21.264 0.662539 20.6005 0 19.7848 0C18.97 0 18.3075 0.662539 18.3075 1.47732C18.3075 1.72447 18.3686 1.95755 18.4767 2.16336L15.2363 5.06719C15.0013 4.90931 14.7175 4.81533 14.413 4.81533C13.945 4.81533 13.5268 5.03429 13.2561 5.37543L10.495 4.13587C10.51 4.05317 10.5175 3.96672 10.5175 3.88026C10.5175 3.06548 9.85406 2.40294 9.03834 2.40294C8.22263 2.40294 7.55915 3.06548 7.55915 3.88026C7.55821 4.09076 7.60144 4.29095 7.68038 4.47139ZM19.7829 0.727449C20.1973 0.727449 20.5347 1.06388 20.5347 1.47739C20.5347 1.89184 20.1983 2.22921 19.7829 2.22921C19.3694 2.22921 19.0329 1.89278 19.0329 1.47739C19.0329 1.06484 19.3694 0.727449 19.7829 0.727449ZM14.4112 5.54391C14.8256 5.54391 15.163 5.88034 15.163 6.29573C15.163 6.70924 14.8265 7.04567 14.4112 7.04567C13.9967 7.04567 13.6593 6.70924 13.6593 6.29573C13.6593 5.88127 13.9958 5.54391 14.4112 5.54391ZM3.66386 8.79658C3.24941 8.79658 2.91204 8.46015 2.91204 8.04476C2.91204 7.63031 3.24847 7.29294 3.66386 7.29294C4.07738 7.29294 4.41381 7.62937 4.41381 8.04476C4.41381 8.46015 4.07738 8.79658 3.66386 8.79658ZM9.03655 3.13159C9.451 3.13159 9.78836 3.46802 9.78836 3.88153C9.78836 4.29598 9.45193 4.63335 9.03655 4.63335C8.62209 4.63335 8.28473 4.29692 8.28473 3.88153C8.28473 3.46802 8.62209 3.13159 9.03655 3.13159Z" fill={color} />
</svg>
  );
};

export const AnalysisIconWhite = () => {
  return (
    <svg
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Group 3</title>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="leaderboard-24px">
          <rect id="Rectangle" x="0" y="0" width="16" height="16"></rect>
          <path
            d="M4.33333333,6.5 L4.5,13.3333333 L2,13.5 L1.83333333,6.66666667 L4.33333333,6.5 Z M9.16666667,2.5 C9.2125,2.5 9.25384822,2.51928833 9.28394661,2.54938672 C9.314045,2.57948512 9.33333333,2.62083333 9.33333333,2.66666667 L9.33333333,2.66666667 L9.33333333,13.3333333 C9.33333333,13.3791667 9.314045,13.4205149 9.28394661,13.4506133 C9.25384822,13.4807117 9.2125,13.5 9.16666667,13.5 L9.16666667,13.5 L6.83333333,13.5 C6.7875,13.5 6.74615178,13.4807117 6.71605339,13.4506133 C6.685955,13.4205149 6.66666667,13.3791667 6.66666667,13.3333333 L6.66666667,13.3333333 L6.66666667,2.66666667 C6.66666667,2.62083333 6.685955,2.57948512 6.71605339,2.54938672 L6.71605339,2.54938672 Z M14,7.83333333 C14.0458333,7.83333333 14.0871816,7.85262166 14.1172799,7.88272006 C14.1473783,7.91281845 14.1666667,7.95416667 14.1666667,8 L14.1666667,8 L14.1666667,13.3333333 C14.1666667,13.3791667 14.1473783,13.4205149 14.1172799,13.4506133 C14.0871816,13.4807117 14.0458333,13.5 14,13.5 L14,13.5 L11.6666667,13.5 C11.6208333,13.5 11.5794851,13.4807117 11.5493867,13.4506133 C11.5192883,13.4205149 11.5,13.3791667 11.5,13.3333333 L11.5,13.3333333 L11.5,8 C11.5,7.95416667 11.5192883,7.91281845 11.5493867,7.88272006 L11.5493867,7.88272006 Z"
            id="Shape"
            stroke="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      className="icon searchIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g stroke="#0036B9" strokeWidth="1.667">
          <g transform="translate(-34 -309) translate(35 310)">
            <circle cx="6.667" cy="6.667" r="6.667" />
            <path d="M15 15L11.375 11.375" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PrintIcon = () => {
  return (
    <svg
      className="icon printIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
    >
      <g fill="none" fillRule="evenodd">
        <g className="fillColor" fill="#FFF" fillRule="nonzero">
          <path
            d="M15.527 3.25h-3.562V.468c0-.26-.21-.469-.468-.469H.469C.209 0 0 .21 0 .469V12.59c0 1.292 1.051 2.343 2.343 2.343h11.31c1.291 0 2.343-1.05 2.343-2.343V3.718c0-.26-.21-.469-.47-.469zM2.343 13.995c-.775 0-1.406-.63-1.406-1.406V.937h10.091c0 12.386-.006 11.698.01 11.874.042.435.204.844.46 1.185H2.343zm12.715-1.406c0 .775-.63 1.406-1.406 1.406h-.28c-.776 0-1.407-.63-1.407-1.406V4.186h3.093v8.404z"
            transform="translate(-132 -158) translate(132 158)"
          />
          <path
            d="M9.497 2.25H2.5c-.259 0-.468.21-.468.468 0 .259.21.469.468.469h6.998c.26 0 .469-.21.469-.469s-.21-.469-.469-.469zM9.497 4.249H2.5c-.259 0-.468.21-.468.468 0 .26.21.47.468.47h6.998c.26 0 .469-.21.469-.47 0-.258-.21-.468-.469-.468zM9.497 11.747H2.5c-.259 0-.468.21-.468.468 0 .26.21.469.468.469h6.998c.26 0 .469-.21.469-.469 0-.258-.21-.468-.469-.468zM9.497 6.248H5.998c-.258 0-.468.21-.468.469v3.499c0 .259.21.469.468.469h3.5c.258 0 .468-.21.468-.47V6.718c0-.259-.21-.469-.469-.469zm-.468 3.5H6.467V7.184h2.562v2.562zM2.5 7.935h1.499c.259 0 .469-.21.469-.468 0-.26-.21-.469-.47-.469H2.5c-.259 0-.468.21-.468.469 0 .258.21.468.468.468zM2.5 9.935h1.499c.259 0 .469-.21.469-.469s-.21-.469-.47-.469H2.5c-.259 0-.468.21-.468.47 0 .258.21.468.468.468z"
            transform="translate(-132 -158) translate(132 158)"
          />
        </g>
      </g>
    </svg>
  );
};

export const SocialIcon = () => {
  return (
    <svg
      className="icon socialIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <g className="fillColor" fill="#FFF" fillRule="nonzero">
          <path
            d="M16.749 5c.27 0 .537.09.753.253.791.598 1.308 1.506 1.418 2.492.058.528 0 1.074-.168 1.581L18.194 11h4.012c.817 0 1.53.527 1.732 1.281.144.538.035 1.096-.299 1.531-.052.068-.107.13-.166.188.059.058.114.12.166.188.334.435.443.993.299 1.53-.107.398-.355.732-.684.959.206.315.288.698.225 1.076-.07.417-.327.773-.68.997.174.3.239.654.18 1.003-.12.712-.782 1.247-1.54 1.247h-5.874c-.774 0-1.549-.183-2.241-.529l-.431-.215c-.195.438-.635.744-1.144.744H9.261c-.69 0-1.25-.561-1.25-1.251v-7.498c0-.69.56-1.251 1.25-1.251H12.5c.157 0 .298.073.39.186l1.939-2.495c.433-.556.671-1.25.671-1.955V6.25c0-.688.56-1.249 1.249-1.249zM12 12H9.261c-.138 0-.25.113-.25.251v7.498c0 .138.112.251.25.251h2.488c.138 0 .251-.113.251-.251V12zm4.5-5.751v.488c0 .925-.313 1.837-.882 2.568L13 12.672v6.518l.772.386c.554.277 1.174.424 1.794.424h5.874c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.097-.113-.236-.179-.382-.179-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.439c.271 0 .514-.181.553-.412.034-.201-.054-.343-.11-.409-.097-.113-.236-.179-.382-.179-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.206c.36 0 .681-.227.765-.54.087-.322-.041-.554-.125-.664-.145-.188-.362-.296-.596-.296-.276 0-.5-.223-.5-.5s.224-.5.5-.5c.234 0 .451-.108.596-.296.084-.11.212-.342.125-.664-.084-.313-.405-.54-.765-.54H17.5c-.16 0-.311-.077-.406-.208-.094-.13-.12-.298-.069-.45l.778-2.333c.122-.369.165-.768.122-1.154-.079-.714-.453-1.372-1.027-1.805-.151-.115-.398.008-.398.199z"
            transform="translate(-334 -122) translate(310 66) translate(16 51)"
          />
        </g>
      </g>
    </svg>
  );
};

export const BlogIcon = () => {
  return (
    <svg
      className="icon blogIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="13"
      viewBox="0 0 16 13"
    >
      <g fill="none" fillRule="evenodd">
        <g className="fillColor" fill="#FFF" fillRule="nonzero">
          <path
            d="M9.253 7C8.568 7 8 7.568 8 8.253v9.802c0 .685.568 1.253 1.253 1.253h9.802c.685 0 1.253-.568 1.253-1.253v-3.093l3.362-3.358c.1-.099.155-.233.155-.373 0-.14-.055-.275-.155-.374l-1.593-1.593c-.1-.1-.237-.156-.38-.154-.137.001-.27.056-.367.154l-1.022 1.022V8.253c0-.685-.568-1.253-1.253-1.253H9.253zm0 1.055h9.802c.12 0 .198.078.198.198v3.093l-3.011 3.017c-.1.099-.154.233-.154.373v1.583c0 .291.236.527.527.527h1.583c.14 0 .274-.055.373-.154l.682-.681v2.044c0 .12-.078.198-.198.198H9.253c-.12 0-.198-.078-.198-.198V8.253c0-.12.078-.198.198-.198zm1.33 1.407c-.19.01-.358.119-.444.287-.085.168-.075.37.028.528.102.158.282.25.47.24h7.033c.19.002.367-.098.463-.262.096-.164.096-.368 0-.532-.096-.164-.272-.264-.463-.261h-7.088zm11.12.923l.846.846-.565.566-.847-.846.566-.566zm-11.12 1.186c-.19.01-.358.12-.444.288-.085.168-.075.37.028.527.102.159.282.25.47.24h6.154c.19.003.367-.097.463-.261.096-.164.096-.368 0-.532-.096-.164-.273-.264-.463-.262h-6.209zm9.807.127l.846.846-3.258 3.247h-.835v-.835l3.247-3.258zm-9.808 1.983c-.188.01-.357.12-.443.288-.085.168-.075.369.028.527.102.159.282.25.47.24h4.22c.19.003.367-.097.463-.261.096-.165.096-.368 0-.532-.096-.164-.273-.264-.463-.262H10.582zm0 2.11c-.188.01-.357.12-.443.288-.085.168-.075.369.028.527.102.159.282.25.47.24h4.22c.19.003.367-.097.463-.261.096-.165.096-.368 0-.532-.096-.165-.273-.264-.463-.262H10.582z"
            transform="translate(-409 -124) translate(310 66) translate(16 51) translate(75)"
          />
        </g>
      </g>
    </svg>
  );
};

export const GlobeIcon = () => {
  return (
    <svg
      className="icon globeIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fillRule="evenodd">
        <g className="fillColor" fill="#FFF" fillRule="nonzero">
          <path
            d="M8 0C3.578 0 0 3.578 0 8c0 4.422 3.578 8 8 8 4.422 0 8-3.578 8-8 0-4.422-3.578-8-8-8zM4.905 1.649c-.243.659-.446 1.33-.61 2.009-.48-.146-.95-.32-1.414-.524.586-.616 1.27-1.117 2.024-1.485zM2.26 3.882c.599.278 1.212.51 1.837.696-.181.968-.285 1.954-.31 2.953H.953c.087-1.326.539-2.581 1.308-3.648zm0 8.235C1.49 11.05 1.04 9.796.953 8.47h2.835c.025.999.129 1.985.31 2.953-.625.186-1.238.418-1.837.695zm.62.75c.463-.204.935-.38 1.414-.525.164.68.367 1.35.61 2.01-.754-.369-1.437-.87-2.024-1.486zm4.65 2.18c-.492-.032-.975-.114-1.441-.245-.371-.878-.667-1.78-.888-2.699.76-.17 1.538-.269 2.33-.297v3.24zm0-4.179c-.857.028-1.7.135-2.523.318-.164-.892-.258-1.798-.282-2.717h2.805v2.399zm0-3.337H4.726c.024-.919.118-1.825.282-2.717.823.183 1.665.29 2.523.318v2.4zm0-3.337c-.791-.028-1.569-.128-2.329-.297.22-.92.517-1.82.888-2.7.466-.13.949-.212 1.441-.244v3.24zm6.208-.312c.77 1.068 1.221 2.323 1.308 3.65h-2.835c-.025-1-.129-1.986-.31-2.954.625-.186 1.238-.418 1.837-.696zm-.62-.748c-.463.203-.935.378-1.414.524-.164-.68-.367-1.35-.61-2.01.754.369 1.437.87 2.024 1.486zM8.469.954c.492.031.975.113 1.441.244.371.878.667 1.78.888 2.699-.76.17-1.538.269-2.33.297V.954zm0 4.178c.857-.028 1.7-.135 2.523-.318.164.892.258 1.798.282 2.717H8.469V5.132zm1.441 9.67c-.466.13-.949.213-1.441.245v-3.24c.791.027 1.569.127 2.329.296-.22.92-.517 1.82-.888 2.7zM8.47 10.868v-2.4h2.805c-.024.92-.118 1.826-.282 2.718-.823-.183-1.666-.29-2.523-.318zm2.626 3.483c.243-.659.446-1.33.61-2.009.48.146.95.32 1.414.524-.586.616-1.27 1.117-2.024 1.485zm2.644-2.234c-.599-.277-1.212-.509-1.837-.695.181-.968.285-1.954.31-2.953h2.835c-.087 1.326-.539 2.581-1.308 3.649z"
            transform="translate(-207 -157) translate(207 157)"
          />
        </g>
      </g>
    </svg>
  );
};

export const ShareIcon = () => {
  return (
    <svg className="icon shareIcon" width="24" height="24" viewBox="0 0 24 24">
      <defs>
        <path id="nzvkys3iaa" d="M0 0H24V24H0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(-1152 -68) translate(105 44) translate(1047 24)">
          <mask id="7gqbbjd76b" fill="#fff">
            <use xlinkHref="#nzvkys3iaa" />
          </mask>
          <g
            stroke="#0036B9"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            mask="url(#7gqbbjd76b)"
          >
            <g transform="translate(3 2)">
              <circle cx="15" cy="3" r="3" />
              <circle cx="3" cy="10" r="3" />
              <circle cx="15" cy="17" r="3" />
              <path d="M5.59 11.51L12.42 15.49M12.41 4.51L5.59 8.49" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

MaleIcon.defaultProps = {
  fillValue: 0,
  fillColor: "#cfd8dc",
};

MaleIcon.propTypes = {
  fillValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fillColor: PropTypes.string,
};

export const NeutralIcon = () => {
  return (
    <svg
      className="icon sentimentIcon newutralIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#E37B0E" fill-rule="nonzero">
          <path
            d="M9 1c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 1.756c-3.994 0-7.244 3.25-7.244 7.244 0 3.994 3.25 7.244 7.244 7.244 3.994 0 7.244-3.25 7.244-7.244 0-3.994-3.25-7.244-7.244-7.244zm2.401 10.692c.506 0 .916.37.916.825 0 .454-.41.825-.916.825H6.6c-.467 0-.852-.316-.909-.722l-.007-.103c0-.456.41-.825.916-.825h4.802zM6.407 6.833c.79 0 1.432.64 1.432 1.432 0 .79-.641 1.431-1.432 1.431-.79 0-1.432-.64-1.432-1.431s.641-1.432 1.432-1.432zm5.186 0c.79 0 1.431.64 1.431 1.431 0 .79-.64 1.432-1.431 1.432-.79 0-1.432-.641-1.432-1.432 0-.79.641-1.431 1.432-1.431z"
            transform="translate(-1253 -239) translate(1245 231) translate(8 7)"
          />
        </g>
      </g>
    </svg>
  );
};

export const PositiveIcon = () => {
  return (
    <svg
      className="icon sentimentIcon positiveIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#35A800" fill-rule="nonzero">
          <path
            d="M12.15 9.1c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zm-6.3 0c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zM8.991 1C4.023 1 0 5.032 0 10s4.023 9 8.991 9C13.968 19 18 14.968 18 10s-4.032-9-9.009-9zM9 17.2c-3.978 0-7.2-3.222-7.2-7.2S5.022 2.8 9 2.8s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2zm0-3.6c-1.327 0-2.475-.729-3.1-1.8H4.391c.72 1.84 2.511 3.15 4.608 3.15 2.097 0 3.888-1.31 4.608-3.15H12.1c-.625 1.071-1.772 1.8-3.1 1.8z"
            transform="translate(-1253 -267) translate(1245 231) translate(8 35)"
          />
        </g>
      </g>
    </svg>
  );
};

export const NegativeIcon = () => {
  return (
    <svg
      className="icon sentimentIcon negativeIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#F40000" fill-rule="nonzero">
          <path
            d="M12.15 9.1c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zm-6.3 0c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zM8.991 1C4.023 1 0 5.032 0 10s4.023 9 8.991 9C13.968 19 18 14.968 18 10s-4.032-9-9.009-9zM9 17.2c-3.978 0-7.2-3.222-7.2-7.2S5.022 2.8 9 2.8s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2zm0-4.95c-1.327 0-2.475.729-3.1 1.8H4.391C5.112 12.21 6.903 10.9 9 10.9c2.097 0 3.888 1.31 4.608 3.15H12.1c-.625-1.071-1.772-1.8-3.1-1.8z"
            transform="translate(-1253 -296) translate(1245 231) translate(8 64)"
          />
        </g>
      </g>
    </svg>
  );
};

export const DefaultSentimentIcon = () => {
  return (
    <svg
      className="icon sentimentIcon defaultSentimentIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#0036B9" fill-rule="nonzero">
          <path
            d="M12.15 8.1c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zm-6.3 0c.747 0 1.35-.603 1.35-1.35 0-.747-.603-1.35-1.35-1.35-.747 0-1.35.603-1.35 1.35 0 .747.603 1.35 1.35 1.35zM8.991 0C4.023 0 0 4.032 0 9s4.023 9 8.991 9C13.968 18 18 13.968 18 9s-4.032-9-9.009-9zM9 16.2c-3.978 0-7.2-3.222-7.2-7.2S5.022 1.8 9 1.8s7.2 3.222 7.2 7.2-3.222 7.2-7.2 7.2zm0-3.6c-1.327 0-2.475-.729-3.1-1.8H4.391c.72 1.84 2.511 3.15 4.608 3.15 2.097 0 3.888-1.31 4.608-3.15H12.1c-.625 1.071-1.772 1.8-3.1 1.8z"
            transform="translate(-1297 -561) translate(108 134) translate(24 424) translate(1165 3)"
          />
        </g>
      </g>
    </svg>
  );
};

export const EmailIcon = ({fill = "#8798AD"}) => {
  return (
    <svg
      className="icon emailIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="15"
      viewBox="0 0 20 15"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill={fill} fill-rule="nonzero">
          <path
            d="M2.143.086C.968.086 0 1.054 0 2.23v10c0 1.175.968 2.143 2.143 2.143h15.714c1.175 0 2.143-.968 2.143-2.143v-10c0-1.175-.968-2.143-2.143-2.143H2.143zm.119 1.429H17.73l-7.247 6.689c-.34.313-.644.313-.983 0l-7.24-6.69zm-.833 1.168l7.098 6.57c.819.757 2.112.756 2.931 0l7.113-6.57v9.546c0 .408-.306.714-.714.714H2.143c-.408 0-.714-.306-.714-.714V2.683z"
            transform="translate(-914 -423) translate(914 423)"
          />
        </g>
      </g>
    </svg>
  );
};

export const SendIcon = ({fill = "#8798AD"}) => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={fill} class="bi bi-send" viewBox="0 0 16 16">
  <path d="M15.854.146a.5.5 0 0 1 .11.54l-5.819 14.547a.75.75 0 0 1-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 0 1 .124-1.33L15.314.037a.5.5 0 0 1 .54.11ZM6.636 10.07l2.761 4.338L14.13 2.576zm6.787-8.201L1.591 6.602l4.339 2.76z"/>
  </svg>
  )
}
export const SaveIcon = ({fill = "#8798AD"}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={fill} class="bi bi-save" viewBox="0 0 16 16">
    <path d="M2 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H9.5a1 1 0 0 0-1 1v7.293l2.646-2.647a.5.5 0 0 1 .708.708l-3.5 3.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L7.5 9.293V2a2 2 0 0 1 2-2H14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h2.5a.5.5 0 0 1 0 1z"/>
    </svg>
  )
}

export const PasswordIcon = () => {
  return (
    <svg
      className="icon passwordIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="23"
      viewBox="0 0 20 23"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#8798AD" fill-rule="nonzero">
          <path
            d="M930.765 500.18h-.934v-3.349c0-3.211-2.62-5.831-5.831-5.831-3.212 0-5.831 2.62-5.831 5.831v3.349h-.934c-1.777 0-3.235 1.458-3.235 3.235v6.606c0 1.776 1.458 3.234 3.235 3.234h13.53c1.777 0 3.235-1.458 3.235-3.234v-6.606c0-1.777-1.435-3.235-3.235-3.235zm-11.23-3.349c0-2.46 2.005-4.464 4.465-4.464s4.442 2.004 4.442 4.442v3.348h-8.907v-3.326zm13.075 13.19c0 1.025-.842 1.845-1.845 1.845h-13.553c-1.025 0-1.845-.843-1.845-1.845v-6.606c0-1.025.843-1.846 1.845-1.846h13.53c1.026 0 1.846.843 1.846 1.846l.022 6.606z"
            transform="translate(-914 -491)"
          />
        </g>
      </g>
    </svg>
  );
};

export const XCircle = () => {
  return (
    <svg
      className="icon xCircle"
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
    >
      <g
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g stroke="#E30E13" stroke-width="1.667">
          <g transform="translate(-913 -534) translate(914 535)">
            <circle cx="8.333" cy="8.333" r="8.333" />
            <path d="M10.833 5.833L5.833 10.833M5.833 5.833L10.833 10.833" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const BlueLock = () => {
  return (
    <svg
      className="icon blueLock"
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="17"
      viewBox="0 0 13 17"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#0036B9" fill-rule="nonzero">
          <path
            d="M11.375 6.667h-.813v-1.62C10.563 2.814 8.742 1 6.5 1S2.437 2.813 2.437 5.048v1.619h-.812C.731 6.667 0 7.395 0 8.286v8.095C0 17.271.731 18 1.625 18h9.75c.894 0 1.625-.729 1.625-1.619V8.286c0-.89-.731-1.62-1.625-1.62zM6.5 13.952c-.894 0-1.625-.728-1.625-1.619 0-.89.731-1.619 1.625-1.619s1.625.729 1.625 1.62c0 .89-.731 1.618-1.625 1.618zm2.519-7.285H3.98v-1.62c0-1.384 1.13-2.509 2.519-2.509 1.39 0 2.519 1.125 2.519 2.51v1.619z"
            transform="translate(-540 -449) translate(506 150) translate(34 298)"
          />
        </g>
      </g>
    </svg>
  );
};

export const TagClose = () => {
  return (
    <svg
      className="icon tagClose"
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
    >
      <g fill="none" fill-rule="evenodd">
        <path
          d="M0 0L12 0 12 12 0 12z"
          transform="translate(-822 -264) translate(132 205) translate(637 57) translate(53 2)"
        />
        <path
          fill="#333"
          fill-rule="nonzero"
          d="M9.5 3.205L8.795 2.5 6 5.295 3.205 2.5 2.5 3.205 5.295 6 2.5 8.795 3.205 9.5 6 6.705 8.795 9.5 9.5 8.795 6.705 6z"
          transform="translate(-822 -264) translate(132 205) translate(637 57) translate(53 2)"
        />
      </g>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      className="icon infoIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#0036B9" fill-rule="nonzero">
          <path
            d="M560 180c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zm.667-13.333c.736 0 1.333.597 1.333 1.333s-.597 1.333-1.333 1.333c-.737 0-1.334-.597-1.334-1.333s.597-1.333 1.334-1.333zm-1 3.333c1.4 0 1.74.811 1.582 1.812l-.649 4.146s.467 0 1.4-.458c0 0-.467 1.833-2.333 1.833-1.4 0-1.74-.81-1.583-1.812l.65-4.146s-.467 0-1.4.458c0 0 .466-1.833 2.333-1.833z"
            transform="translate(-552 -164)"
          />
        </g>
      </g>
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      className="icon eyeIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="13"
      viewBox="0 0 18 13"
    >
      <g
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g stroke="#938FA9" stroke-width="2">
          <g transform="translate(-938 -438) translate(445 164) translate(24 224) translate(0 36) translate(470 15)">
            <path d="M0 5.5S2.91 0 8 0s8 5.5 8 5.5S13.09 11 8 11 0 5.5 0 5.5z" />
            <ellipse cx="8" cy="5.5" rx="2.182" ry="2.063" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const EyeOffIcon = () => {
  return (
    <svg
      className="icon eyeOffIcon"
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <g
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <g stroke="#938FA9" stroke-width="2">
          <path
            d="M12.32 12.32c-1.243.948-2.757 1.473-4.32 1.498C2.91 13.818 0 8 0 8c.905-1.686 2.16-3.159 3.68-4.32m2.793-1.324c.5-.117 1.013-.175 1.527-.174C13.09 2.182 16 8 16 8c-.441.826-.968 1.603-1.57 2.32m-4.888-.778c-.544.584-1.363.824-2.136.626-.773-.197-1.377-.8-1.574-1.574-.198-.773.042-1.592.626-2.136M0 0L16 16"
            transform="translate(-938 -335) translate(445 164) translate(24 124) translate(0 36) translate(470 12)"
          />
        </g>
      </g>
    </svg>
  );
};

export const YoutubePlayIcon = ({cla}) => (
  <svg
    className={"icon youtubePlayIcon "+(cla?cla:"")}
    width="15px"
    height="10px"
    viewBox="0 0 15 10"
    version="1.1"
    xmlns="http://www.w3.org/1999/xlink"
  >
    <title>116-youtube</title>
    <g
      id="Feeds-Details"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="CBIU-Social-Feeds-details-v07-Youtube"
        transform="translate(-346.000000, -172.000000)"
        fill="#E53935"
        fill-rule="nonzero"
      >
        <g id="116-youtube" transform="translate(346.000000, 172.000000)">
          <path
            d="M0.335360624,8.44263736 C0.641013645,9.46124542 1.57606238,9.64761905 1.63844055,9.68336996 C3.17730994,10.0772161 11.802963,10.0783883 13.3649123,9.68336996 C14.4346979,9.39267399 14.6311891,8.50124542 14.6679922,8.44263736 C15.0753216,6.40659341 15.1021442,3.75223443 14.6492788,1.44190476 L14.6679922,1.55677656 C14.3623392,0.538168498 13.4272904,0.351794872 13.3649123,0.316043956 C11.8466277,-0.0713553114 3.19851852,-0.086007326 1.63844055,0.316043956 C0.568654971,0.607326007 0.372163743,1.4981685 0.335360624,1.55677656 C-0.100662768,3.69655678 -0.122495127,6.15164835 0.335360624,8.44263736 Z M6.00304094,7.13978022 L6.00304094,2.86549451 L9.91165692,5.00586081 L6.00304094,7.13978022 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const TwitterIcon = ({cla}) => (
  <svg
    className={"icon twitterIcon "+(cla?cla:"")}
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="13"
    viewBox="0 0 15 13"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#55ACEE" fill-rule="nonzero">
        <path
          d="M13.47 3.447c0-.136-.005-.268-.011-.398.61-.433 1.123-.974 1.541-1.596-.558.244-1.152.406-1.772.485.638-.38 1.124-.979 1.353-1.7-.594.355-1.25.605-1.95.745C12.067.382 11.262.01 10.385.01c-1.703 0-3.073 1.382-3.073 3.075 0 .244.02.479.071.702C4.827 3.662 2.564 2.437 1.044.57c-.265.46-.42.987-.42 1.554 0 1.065.547 2.009 1.365 2.556C1.495 4.67 1.011 4.527.6 4.3v.034c0 1.494 1.066 2.735 2.464 3.022-.47.128-1.049.123-1.388.048.398 1.218 1.529 2.114 2.873 2.143-1.047.818-2.375 1.311-3.813 1.311-.252 0-.494-.011-.736-.042 1.363.878 2.976 1.38 4.718 1.38 5.658 0 8.752-4.687 8.752-8.75z"
          transform="translate(-324 -974) translate(108 210) translate(216 764)"
        />
      </g>
    </g>
  </svg>
);

export const MenuIcon = () => (
  <svg
    className="icon menuIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="13"
    viewBox="0 0 16 13"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g stroke="#0036B9" stroke-width="2">
        <path
          d="M0 5.444L14 5.444M0 .778L14 .778M0 10.111L14 10.111"
          transform="translate(-22 -22) translate(16 14) translate(7 9)"
        />
      </g>
    </g>
  </svg>
);

export const ArrowLeftIcon = ({color='#0036B9'}) => (
  <svg
    className="icon arrowLeftIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <g
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g stroke={color} stroke-width="2">
        <path
          d="M12 6L0 6M6 12L0 6 6 0"
          transform="translate(-15 -21) translate(16 22)"
        />
      </g>
    </g>
  </svg>
);

export const PinterestIcon = () => (
  <svg
    className="icon pinterestIcon"
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Feeds-Listing"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="CBIU-Social-v07-Rev03-Details-Pinterest"
        transform="translate(-214.000000, -778.000000)"
        fill="#CB1F24"
        fill-rule="nonzero"
      >
        <g id="Group-12" transform="translate(108.000000, 210.000000)">
          <g id="pinterest" transform="translate(106.000000, 568.000000)">
            <path
              d="M8.99792982,0 C4.04210526,0 0.0154736842,4.02663158 0.0154736842,8.98245614 C0.0154736842,12.6683509 2.21463158,15.8277193 5.40494737,17.2215439 C5.37396491,16.6020702 5.40494737,15.8277193 5.55982456,15.1462807 C5.74568421,14.4029123 6.70585965,10.252386 6.70585965,10.252386 C6.70585965,10.252386 6.42708772,9.66389474 6.42708772,8.82757895 C6.42708772,7.49568421 7.2014386,6.50452632 8.16161404,6.50452632 C8.96694737,6.50452632 9.36961404,7.124 9.36961404,7.86736842 C9.36961404,8.67270175 8.84305263,9.91164912 8.5642807,11.0576842 C8.34747368,12.0178947 9.02887719,12.7922105 9.98908772,12.7922105 C11.6926667,12.7922105 12.8387018,10.5930526 12.8387018,8.02221053 C12.8387018,6.03985965 11.506807,4.58410526 9.09084211,4.58410526 C6.36512281,4.58410526 4.66157895,6.62838596 4.66157895,8.88947368 C4.66157895,9.66382456 4.87838596,10.2213684 5.25007018,10.6549825 C5.40494737,10.8408421 5.43592982,10.9337544 5.37396491,11.1505614 C5.34298246,11.3054386 5.21908772,11.7081053 5.18810526,11.8629474 C5.12614035,12.0797544 4.94031579,12.1727018 4.72350877,12.0797544 C3.45357895,11.553193 2.89603509,10.1903509 2.89603509,8.64164912 C2.89603509,6.10178947 5.03322807,3.03536842 9.30764912,3.03536842 C12.7457544,3.03536842 15.0068772,5.51329825 15.0068772,8.17705263 C15.0068772,11.7080702 13.0555088,14.3408772 10.1749474,14.3408772 C9.21473684,14.3408772 8.28554386,13.8143158 7.97578947,13.2258246 C7.97578947,13.2258246 7.44922807,15.3010877 7.35631579,15.7037544 C7.17045614,16.385193 6.79877193,17.0975789 6.45807018,17.6241404 C7.26340351,17.8719298 8.13066667,17.9958246 8.99792982,17.9958246 C13.9537544,17.9958246 17.980386,13.969193 17.980386,9.01336842 C17.980386,4.05754386 13.9537895,0 8.99792982,0"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const LoginIcon = () => (
  <svg
    className="loginIcon icon"
    width="15px"
    height="18px"
    viewBox="0 0 15 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Navigation"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Navigation-Revised"
        transform="translate(-955.000000, -375.000000)"
        fill="#0036B9"
        fill-rule="nonzero"
      >
        <g id="Group-48" transform="translate(920.000000, 172.000000)">
          <g
            id="noun_Login_301022"
            transform="translate(35.000000, 203.000000)"
          >
            <g id="Group" transform="translate(-0.000000, 0.000000)">
              <path
                d="M14.400648,0.00910100327 C10.6433997,0.00572643139 3.74757455,-0.00957162777 3.24791294,0.00910100327 C2.61956766,0.0324980349 2.61866777,0.535309244 2.62361715,1.15195601 C2.61866777,2.0545415 2.6294664,4.07118565 2.6294664,4.07118565 C2.6294664,4.07118565 3.49538155,4.07118565 3.94015012,4.07118565 C3.94015012,3.1186565 3.94015012,2.18682472 3.94015012,1.25724265 C7.21258495,1.25724265 10.4445249,1.25724265 13.683889,1.25724265 C13.683889,6.37421847 13.683889,11.4659975 13.683889,16.5658755 C10.4258523,16.5658755 7.18581335,16.5658755 3.91945275,16.5658755 C3.91945275,15.6421427 3.91945275,14.7456314 3.91945275,13.8360718 C3.4807584,13.8360718 3.06838572,13.8360718 2.63261601,13.8360718 C2.63261601,14.7973748 2.64971384,15.7361807 2.62384212,16.6736368 C2.60674429,17.2968077 2.69290836,17.783871 3.24768797,17.8171667 C3.33790153,17.822566 10.6832196,17.8171667 14.400423,17.8171667 C14.8951353,17.8171667 15.0019967,17.7888203 15,17.2776852 C15,11.7010927 15,6.12517507 15,0.548807532 C15.000197,0.0606194672 14.7702761,-0.00934665631 14.400648,0.00910100327 Z"
                id="Path"
              ></path>
              <path
                d="M9.97995886,9.5103206 C9.89087016,9.60503359 9.84295124,9.66150142 9.78918307,9.71234497 C9.09987052,10.3647622 8.40650848,11.0135799 7.72192033,11.6700466 C7.47985105,11.9024421 7.45015481,12.1820816 7.61145935,12.4284254 C7.77906309,12.6844429 8.11562039,12.7949039 8.40290894,12.6720695 C8.51022032,12.6266252 8.61145748,12.5530596 8.69717161,12.4727448 C9.78918307,11.4462 10.8791698,10.4183054 11.9660069,9.3865863 C12.3318105,9.03968031 12.3311356,8.73281924 11.965332,8.387938 C10.8757952,7.35914352 9.78378375,6.33349864 8.68974755,5.30920359 C8.36038933,5.00031778 7.93811791,4.98524469 7.67692604,5.26218455 C7.41730898,5.53732465 7.46410304,5.86218343 7.81775818,6.19784085 C8.47759946,6.82348648 9.13991544,7.4459825 9.7999817,8.07117818 C9.85082524,8.11932208 9.89087016,8.1782646 9.97118498,8.2736525 L0.339931874,8.27927678 C0.152305677,8.27927678 -7.99259177e-16,8.41268486 -7.99259177e-16,8.60031105 L-7.99259177e-16,9.15981507 C-7.99259177e-16,9.34721629 0.152305677,9.499297 0.339931874,9.499297 C0.339931874,9.499297 9.84947542,9.50379643 9.97995886,9.5103206 Z"
                id="Path"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const QualitativeIcon = () => (
  <svg
    class="icon analysisIcon"
    xmlns="http://www.w3.org/2000/svg"
    width="23"
    height="30"
    version="1.1"
    viewBox="0 0 700 700"
  >
    <g>
      <path d="m186.67 0h186.67v93.332h-186.67z" />
      <path d="m604.33 338.33-81.664 81.668 81.668 81.668c34.996-51.336 34.996-114.34-0.003907-163.34z" />
      <path d="m466.67 282.33c-65.332 11.668-116.67 67.668-116.67 137.67 0 77 63 140 140 140 30.332 0 58.332-9.332 81.668-25.668l-105-105z" />
      <path d="m513.33 282.33v81.668l58.332-58.332c-16.332-11.668-37.332-21-58.332-23.336z" />
      <path d="m303.33 420c0-102.67 84-186.67 186.67-186.67v-186.66h-70v93.332h-280v-93.332h-70v513.33h296.33c-37.332-35-63-84-63-140zm-46.664 23.332h-93.336v-46.668h93.332zm0-93.332h-93.336v-46.668h93.332zm0-93.332h-93.336v-46.668h93.332z" />
    </g>
  </svg>
);
export const ProfileFilledIcon = () => {
  return (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
    <path d="M5.89021 6.78493C7.62935 6.78493 9.04372 4.92654 9.04372 3.1757C9.04372 1.42471 7.62935 0 5.89021 0C4.15136 0 2.73669 1.42457 2.73669 3.17555C2.73684 4.92654 4.1515 6.78493 5.89021 6.78493Z" fill="#F55842"/>
    <path d="M8.25777 6.81738C7.64591 7.28667 6.8828 7.566 6.05617 7.566H5.72419C4.89756 7.566 4.1343 7.28667 3.52259 6.81738C1.52523 7.1425 0 8.88578 0 10.9885C0 12.1436 2.63707 13.0801 5.89018 13.0801C9.14328 13.0801 11.7804 12.1436 11.7804 10.9885C11.7804 8.88578 10.255 7.1425 8.25777 6.81738Z" fill="#F55842"/>
  </svg>)
};
export const DateIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 1.5V0.75C9 0.336 9.336 0 9.75 0C10.164 0 10.5 0.336 10.5 0.75V1.5C12.1575 1.5 13.5 2.84325 13.5 4.5V12C13.5 13.6567 12.1575 15 10.5 15C8.35575 15 5.145 15 3 15C1.34325 15 0 13.6567 0 12V4.5C0 2.84325 1.34325 1.5 3 1.5V0.75C3 0.336 3.336 0 3.75 0C4.164 0 4.5 0.336 4.5 0.75V1.5H9ZM12 7.5H1.5V12C1.5 12.828 2.172 13.5 3 13.5C5.145 13.5 8.35575 13.5 10.5 13.5C11.3287 13.5 12 12.828 12 12V7.5ZM8.16975 10.2412L9.22725 9.21225C9.52425 8.9235 9.999 8.93026 10.2877 9.22726C10.5765 9.52351 10.5697 9.999 10.2735 10.2877L8.7315 11.7877C8.4555 12.0555 8.02275 12.072 7.728 11.826L6.8835 11.121C6.5655 10.8563 6.52275 10.383 6.78825 10.065C7.053 9.747 7.52625 9.70425 7.84425 9.96975L8.16975 10.2412ZM10.5 3V3.75C10.5 4.164 10.164 4.5 9.75 4.5C9.336 4.5 9 4.164 9 3.75V3H4.5V3.75C4.5 4.164 4.164 4.5 3.75 4.5C3.336 4.5 3 4.164 3 3.75V3C2.172 3 1.5 3.67125 1.5 4.5V6H12V4.5C12 3.67125 11.3287 3 10.5 3Z" fill="#0036B9"/>
    </svg>)
};
export const TimeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 0C10.4774 0 13.5 3.02201 13.5 6.75C13.5 10.478 10.478 13.5 6.75 13.5C3.02258 13.5 0 10.478 0 6.75C0 3.02201 3.02258 0 6.75 0ZM6.17381 3.81013V6.75043C6.17381 6.96358 6.28927 7.14954 6.46134 7.24946L8.94705 8.68543C9.22293 8.8453 9.57598 8.75093 9.73584 8.47504C9.89571 8.19915 9.80135 7.84612 9.52546 7.68625L7.3261 6.41618V3.80997C7.3261 3.49134 7.06853 3.23378 6.7499 3.23378C6.43127 3.23378 6.17371 3.4919 6.17371 3.80997L6.17381 3.81013ZM10.7051 2.79541C8.52082 0.611109 4.97984 0.611109 2.79554 2.79541C0.611237 4.97914 0.611237 8.52069 2.79554 10.705C4.97927 12.8893 8.52082 12.8893 10.7051 10.705C12.8894 8.52069 12.8894 4.97971 10.7051 2.79541Z" fill="#0036B9"/>
    </svg>)
};
export const SendTicketIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="30" viewBox="0 0 24 30" fill="none">
    <path d="M12.2131 15.4871L5.5563 15.7834C4.86444 15.8165 4.19751 16.094 3.64379 16.579C3.09007 17.0641 2.67567 17.7339 2.45544 18.4998L0.57164 25.1918V25.3894C0.577194 26.5008 0.95808 27.5648 1.63169 28.3507C2.30529 29.1365 3.2173 29.5809 4.16991 29.5874C4.80555 29.5879 5.42997 29.3919 5.97962 29.0194L8.65716 27.2661C8.90135 27.1024 9.07979 26.8322 9.15322 26.515C9.22666 26.1978 9.18907 25.8595 9.04873 25.5746C8.90839 25.2897 8.67679 25.0815 8.40489 24.9959C8.13298 24.9102 7.84303 24.954 7.59884 25.1178L4.91073 26.9328C4.69665 27.0763 4.45523 27.1551 4.20842 27.162C3.9616 27.169 3.7172 27.1039 3.49744 26.9726C3.27768 26.8413 3.08951 26.6481 2.95004 26.4104C2.81058 26.1727 2.72423 25.8982 2.69885 25.6116L4.46623 19.327C4.54933 19.0359 4.70605 18.7811 4.91574 18.5959C5.12544 18.4108 5.37828 18.3041 5.64096 18.2899L12.393 17.9935C13.0947 17.9788 13.7627 17.6395 14.2499 17.0502C14.7372 16.4609 15.0038 15.6699 14.9912 14.8512C14.9785 14.0326 14.6877 13.2533 14.1826 12.6848C13.6774 12.1164 12.9995 11.8053 12.2978 11.82L5.63038 11.5114C5.37001 11.499 5.11906 11.3943 4.91105 11.2112C4.70304 11.0281 4.54786 10.7753 4.46623 10.4866L2.69885 4.2143C2.71726 3.93914 2.79352 3.67351 2.92089 3.44092C3.04826 3.20833 3.22281 3.01596 3.42909 2.88083C3.65558 2.72681 3.91304 2.64566 4.1752 2.64566C4.43736 2.64566 4.69482 2.72681 4.92131 2.88083L20.5209 13.3881C20.7464 13.5386 20.9338 13.7561 21.0639 14.0186C21.1941 14.281 21.2623 14.5789 21.2617 14.8821C21.2639 15.189 21.1965 15.491 21.0664 15.7577C20.9363 16.0244 20.7481 16.2463 20.5209 16.4008L11.4405 22.5002C11.2102 22.671 11.0453 22.9391 10.9804 23.2484C10.9154 23.5577 10.9554 23.8844 11.092 24.1601C11.2286 24.4358 11.4513 24.6393 11.7134 24.728C11.9756 24.8167 12.257 24.7838 12.4988 24.6362L21.5792 18.5368C22.1341 18.1616 22.5934 17.6207 22.9096 16.9696C23.2258 16.3186 23.3876 15.581 23.3783 14.8327C23.3788 14.0981 23.2127 13.3764 22.8967 12.741C22.5807 12.1056 22.1261 11.5791 21.5792 11.215L5.96904 0.720102C5.41719 0.352667 4.79196 0.16173 4.15658 0.166595C3.52119 0.171459 2.89817 0.371952 2.3505 0.747806C1.80283 1.12366 1.34992 1.66155 1.03757 2.30709C0.725218 2.95264 0.564491 3.68295 0.57164 4.4242V4.62175L2.45544 11.215C2.67567 11.9809 3.09007 12.6508 3.64379 13.1358C4.19751 13.6209 4.86444 13.8983 5.5563 13.9314L12.1284 14.2277C12.1934 14.2324 12.2568 14.2522 12.3151 14.2859C12.3734 14.3197 12.4253 14.3667 12.4677 14.4243C12.5101 14.4818 12.5422 14.5487 12.5621 14.621C12.582 14.6933 12.5893 14.7695 12.5835 14.8451C12.6054 14.9873 12.579 15.1338 12.5099 15.2537C12.4407 15.3736 12.3343 15.4573 12.2131 15.4871Z" fill="white"/>
    </svg>)
};
export const TicketBackIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
    <path d="M14.0121 0.777118H3.88114C3.60262 0.777118 3.37467 1.00507 3.37467 1.28358C3.37467 1.5621 3.60262 1.79005 3.88114 1.79005H14.0121C14.2906 1.79005 14.5186 2.018 14.5186 2.29652V15.9734C14.5186 16.5305 14.0627 16.9864 13.5056 16.9864C12.9486 16.9864 12.4927 16.5305 12.4927 15.9734V4.32307C12.4927 3.4875 11.8088 2.80366 10.9732 2.80366H1.85529C1.01972 2.80366 0.335876 3.4875 0.335876 4.32307V16.4806C0.335876 17.3162 1.01972 18 1.85529 18H13.5064C14.6262 18 15.5322 17.0932 15.5322 15.9742V2.29652C15.5322 1.46095 14.8484 0.7771 14.0128 0.7771L14.0121 0.777118ZM1.85531 16.9872C1.57679 16.9872 1.34884 16.7592 1.34884 16.4807V4.32322C1.34884 4.0447 1.57679 3.81675 1.85531 3.81675H10.9733C11.2518 3.81675 11.4797 4.0447 11.4797 4.32322V15.9743C11.4797 16.344 11.5809 16.6888 11.7533 16.9873L1.85531 16.9872ZM9.95953 4.82968H2.8674C2.58889 4.82968 2.36094 5.05763 2.36094 5.33615V7.8693C2.36094 8.14782 2.58889 8.37576 2.8674 8.37576H9.95953C10.238 8.37576 10.466 8.14782 10.466 7.8693V5.33615C10.466 5.05763 10.238 4.82968 9.95953 4.82968ZM9.45306 7.36283H3.37467V5.84342H9.45306V7.36283ZM10.4667 9.89525C10.4667 10.1738 10.2388 10.4017 9.96026 10.4017H2.86813C2.58962 10.4017 2.36167 10.1738 2.36167 9.89525C2.36167 9.61674 2.58962 9.38879 2.86813 9.38879H9.96026C10.2388 9.38879 10.4667 9.61674 10.4667 9.89525ZM10.4667 11.9218C10.4667 12.2003 10.2388 12.4283 9.96026 12.4283H2.86813C2.58962 12.4283 2.36167 12.2003 2.36167 11.9218C2.36167 11.6433 2.58962 11.4153 2.86813 11.4153H9.96026C10.2388 11.4153 10.4667 11.6433 10.4667 11.9218Z" fill="white"/>
    </svg>)
};
export const TicketStatusIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
    <path d="M17.3722 7.26504H17.0693C16.9272 7.26504 16.8037 7.17356 16.7691 7.04389C16.5986 6.43107 16.3526 5.83778 16.0364 5.27826C15.9698 5.16102 15.992 5.01004 16.0897 4.90879L16.3073 4.69386C16.484 4.51356 16.5853 4.27732 16.5853 4.0242C16.5853 3.77196 16.484 3.53127 16.3073 3.35453L14.9653 2.01255C14.6083 1.65552 13.983 1.65552 13.626 2.01255L13.411 2.23015C13.3098 2.32784 13.1588 2.35005 13.0416 2.28344C12.4829 1.96726 11.8888 1.72123 11.2759 1.5507C11.1463 1.51607 11.0548 1.39262 11.0548 1.25051V0.947662C11.0548 0.426311 10.6285 0 10.1071 0H8.2127C7.69135 0 7.26504 0.426311 7.26504 0.947662V1.25051C7.26504 1.39262 7.17356 1.51608 7.04389 1.5507C6.43107 1.72123 5.83778 1.96724 5.27826 2.28344C5.16102 2.35005 5.01004 2.32784 4.90879 2.23015L4.69386 2.01255C4.33682 1.65552 3.71157 1.65552 3.35453 2.01255L2.01255 3.35453C1.83581 3.53128 1.73455 3.77107 1.73455 4.0242C1.73455 4.27644 1.8358 4.51356 2.01255 4.69386L2.23015 4.90879C2.32784 5.01004 2.35005 5.16103 2.28344 5.27826C1.96726 5.8369 1.72123 6.43107 1.5507 7.04389C1.51607 7.17356 1.39262 7.26504 1.25051 7.26504H0.947662C0.426311 7.26504 0 7.69135 0 8.2127V10.1071C0 10.6285 0.426311 11.0548 0.947662 11.0548H1.25051C1.39262 11.0548 1.51608 11.1463 1.5507 11.2759C1.72123 11.8888 1.96724 12.482 2.28344 13.0416C2.35005 13.1588 2.32784 13.3098 2.23015 13.411L2.01255 13.626C1.83581 13.8063 1.73455 14.0425 1.73455 14.2956C1.73455 14.5479 1.8358 14.7886 2.01255 14.9653L3.35453 16.3073C3.71157 16.6643 4.33682 16.6643 4.69386 16.3073L4.90879 16.0897C5.01004 15.992 5.16103 15.9698 5.27826 16.0364C5.8369 16.3526 6.43107 16.5986 7.04389 16.7691C7.17356 16.8038 7.26504 16.9272 7.26504 17.0693V17.3722C7.26504 17.8935 7.69135 18.3198 8.2127 18.3198H10.1071C10.6285 18.3198 11.0548 17.8935 11.0548 17.3722V17.1919C10.6791 16.9645 10.4233 16.5506 10.4233 16.0799V15.5053C10.4233 14.9431 10.7866 14.4635 11.2884 14.2867C11.3612 14.0532 11.4491 13.8258 11.5566 13.6082C10.8425 13.9936 10.0254 14.2148 9.15948 14.2148C6.37424 14.2148 4.10672 11.9473 4.10672 9.16205C4.10672 6.37674 6.37418 4.10929 9.15948 4.10929C11.9448 4.10929 14.2122 6.37674 14.2122 9.16205C14.2122 9.92941 14.0382 10.6586 13.7326 11.3096C13.7388 11.3131 13.7486 11.3158 13.7548 11.3194C14.0355 11.1773 14.3135 11.0636 14.6012 10.9748C14.778 10.473 15.2585 10.1097 15.8198 10.1097H16.3944C16.9566 10.1097 17.4362 10.473 17.613 10.9748C17.6378 10.981 17.6636 10.9907 17.6858 10.9996C18.0517 10.87 18.3173 10.52 18.3173 10.1088V8.2144C18.3173 7.69304 17.8909 7.26673 17.3696 7.26673L17.3722 7.26504Z" fill="#0036B9"/>
    <path d="M9.9222 5.72764C9.73302 5.50027 9.45503 5.37061 9.16104 5.37061C8.86706 5.37061 8.58908 5.50027 8.39989 5.72764L7.13073 7.24992C7.0135 7.38847 6.95044 7.56876 6.95044 7.74906C6.95044 8.17892 7.30127 8.52886 7.73024 8.52886H7.89721C8.07129 8.52886 8.21339 8.67096 8.21339 8.84503V12.0034C8.21339 12.5247 8.6397 12.951 9.16105 12.951C9.6824 12.951 10.1087 12.5247 10.1087 12.0034V8.84503C10.1087 8.67096 10.2508 8.52886 10.4249 8.52886H10.5919C11.0217 8.52886 11.3717 8.17803 11.3717 7.74906C11.3717 7.56877 11.3086 7.38937 11.1914 7.24992L9.9222 5.72764Z" fill="#0036B9"/>
    <path d="M16.3962 20.844H15.8215C15.4574 20.844 15.1616 20.5474 15.1616 20.1832V20.1282C15.1616 20.1122 15.1439 20.1015 15.1279 20.098C14.6376 19.987 14.1731 19.7942 13.7486 19.5251L13.6731 19.5678C13.4244 19.8165 12.9892 19.8173 12.7397 19.5669L12.3338 19.161C12.2085 19.0366 12.1401 18.8706 12.1401 18.6938C12.1401 18.5171 12.2085 18.351 12.3338 18.2266L12.3791 18.1813C12.1064 17.7275 11.9137 17.263 11.8026 16.7727C11.7991 16.7559 11.7875 16.7381 11.7724 16.7381H11.7174C11.3532 16.7381 11.0575 16.4415 11.0575 16.0773V15.5036C11.0575 15.1395 11.3533 14.8428 11.7174 14.8428H11.7724C11.7875 14.8428 11.7991 14.826 11.8026 14.8082C11.9137 14.3179 12.1064 13.8543 12.3755 13.4298L12.3329 13.3543C12.2085 13.23 12.1392 13.0639 12.1392 12.888C12.1392 12.7113 12.2076 12.5452 12.3329 12.4208L12.7388 12.0149C12.9883 11.7654 13.4235 11.7654 13.6722 12.0149L13.7184 12.0602C14.1722 11.7876 14.6367 11.5948 15.127 11.4838C15.143 11.4803 15.1607 11.4687 15.1607 11.4536V11.3986C15.1607 11.0344 15.4565 10.7378 15.8206 10.7378H16.3952C16.7594 10.7378 17.0551 11.0344 17.0551 11.3986V11.4536C17.0551 11.4696 17.0729 11.4803 17.0889 11.4838C17.5791 11.5948 18.0436 11.7876 18.4682 12.0567L18.5437 12.014C18.7924 11.7654 19.2275 11.7645 19.4771 12.0149L19.883 12.4208C20.0082 12.5452 20.0766 12.7112 20.0766 12.888C20.0766 13.0647 20.0082 13.2308 19.883 13.3552L19.8377 13.4005C20.1104 13.8543 20.3031 14.3188 20.4141 14.8091C20.4177 14.8259 20.4292 14.8437 20.4443 14.8437H20.4994C20.8635 14.8437 21.1593 15.1403 21.1593 15.5045V16.0782C21.1593 16.4424 20.8635 16.739 20.4994 16.739H20.4443C20.4292 16.739 20.4177 16.7559 20.4141 16.7736C20.3031 17.2639 20.1104 17.7275 19.8413 18.152L19.8839 18.2275C20.0083 18.3519 20.0775 18.5179 20.0775 18.6938C20.0775 18.8705 20.0091 19.0366 19.8839 19.161L19.478 19.5669C19.2284 19.8164 18.7933 19.8164 18.5446 19.5669L18.4984 19.5216C18.0445 19.7942 17.58 19.987 17.0898 20.098C17.0738 20.1015 17.056 20.1131 17.056 20.1282V20.1832C17.056 20.5474 16.7603 20.844 16.3962 20.844ZM13.7273 18.8865C13.8508 18.8865 13.9751 18.9212 14.087 18.9922C14.4503 19.2222 14.8482 19.3874 15.2674 19.4825C15.5773 19.5526 15.7932 19.8182 15.7932 20.129V20.1841C15.7932 20.2001 15.8065 20.2125 15.8216 20.2125H16.3962C16.4122 20.2125 16.4246 20.1992 16.4246 20.1841V20.129C16.4246 19.8191 16.6404 19.5526 16.9504 19.4825C17.3705 19.3874 17.7675 19.2222 18.1308 18.9922C18.3945 18.8252 18.7285 18.8599 18.9452 19.0757L18.9905 19.121C18.9896 19.1201 19.0278 19.1219 19.0313 19.1219L19.4372 18.716V18.6751L19.391 18.629C19.1761 18.414 19.1415 18.0792 19.3084 17.8154C19.5385 17.4513 19.7037 17.0543 19.7987 16.6342C19.8697 16.3242 20.1353 16.1084 20.4453 16.1084H20.5003C20.5163 16.1084 20.5288 16.0951 20.5288 16.08V15.5062C20.5288 15.4903 20.5154 15.4778 20.5003 15.4778H20.4453C20.1353 15.4778 19.8689 15.2611 19.7987 14.952C19.7037 14.5319 19.5385 14.1349 19.3084 13.7708C19.1415 13.507 19.1761 13.1722 19.3919 12.9573L19.4372 12.9111V12.8702L19.0313 12.4643C19.0313 12.4643 18.9905 12.4643 18.9905 12.4652L18.9443 12.5114C18.7285 12.7272 18.3936 12.761 18.1308 12.594C17.7675 12.364 17.3696 12.1988 16.9504 12.1038C16.6404 12.0336 16.4246 11.768 16.4246 11.4572V11.4021C16.4246 11.3861 16.4113 11.3737 16.3962 11.3737H15.8216C15.8056 11.3737 15.7932 11.387 15.7932 11.4021V11.4572C15.7932 11.7671 15.5773 12.0336 15.2674 12.1038C14.8473 12.1988 14.4503 12.364 14.087 12.594C13.8241 12.761 13.4893 12.7272 13.2726 12.5105L13.2273 12.4652C13.2273 12.4634 13.19 12.4643 13.1864 12.4643L12.7806 12.8702V12.9111L12.8267 12.9573C13.0417 13.1722 13.0763 13.507 12.9093 13.7708C12.6793 14.1349 12.5141 14.532 12.4191 14.952C12.348 15.262 12.0825 15.4778 11.7725 15.4778H11.7174C11.7015 15.4778 11.689 15.4911 11.689 15.5062V16.08C11.689 16.096 11.7023 16.1084 11.7174 16.1084H11.7725C12.0825 16.1084 12.3489 16.3251 12.4191 16.6342C12.5141 17.0543 12.6793 17.4513 12.9093 17.8154C13.0763 18.0792 13.0417 18.414 12.8258 18.629L12.7806 18.6751V18.716L13.1864 19.1219C13.1864 19.1219 13.2273 19.1219 13.2273 19.121L13.2735 19.0748C13.3978 18.9505 13.5612 18.8865 13.7273 18.8865Z" fill="#0036B9"/>
    <path d="M14.8454 17.6867C14.7646 17.6867 14.6838 17.6556 14.6225 17.5943L13.0434 16.0152C12.9199 15.8917 12.9199 15.6919 13.0434 15.5684L14.6225 13.9893C14.746 13.8659 14.9458 13.8659 15.0692 13.9893C15.1927 14.1128 15.1927 14.3126 15.0692 14.436L13.7139 15.7914L15.0692 17.1467C15.1927 17.2701 15.1927 17.47 15.0692 17.5934C15.008 17.6547 14.9271 17.6858 14.8463 17.6858L14.8454 17.6867Z" fill="#0036B9"/>
    <path d="M17.3722 17.6865C17.2913 17.6865 17.2105 17.6554 17.1492 17.5941C17.0258 17.4707 17.0258 17.2708 17.1492 17.1474L18.5045 15.7921L17.1492 14.4368C17.0258 14.3133 17.0258 14.1135 17.1492 13.99C17.2727 13.8666 17.4725 13.8666 17.596 13.99L19.1751 15.5692C19.2985 15.6926 19.2985 15.8925 19.1751 16.0159L17.596 17.595C17.5347 17.6563 17.4539 17.6874 17.373 17.6874L17.3722 17.6865Z" fill="#0036B9"/>
    <path d="M15.7932 17.6866C15.7727 17.6866 15.7514 17.6849 15.731 17.6804C15.5605 17.6458 15.4495 17.4797 15.4832 17.3092L16.1147 14.1508C16.1484 13.9794 16.3163 13.8693 16.4859 13.9031C16.6565 13.9377 16.7675 14.1038 16.7337 14.2743L16.1022 17.4326C16.0721 17.5827 15.9406 17.6866 15.7932 17.6866Z" fill="#0036B9"/>
    </svg>)
};
export const TicketStatusSaveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path d="M0.14625 7.39406C0.0506251 7.92844 0 8.46844 0 9C0 13.9641 4.03875 18 9 18C13.9613 18 18 13.9641 18 9C18 4.03594 13.9613 0 9 0C8.46844 0 7.92844 0.0478126 7.39406 0.14625C6.78375 0.255938 6.37594 0.840937 6.48563 1.45406C6.59531 2.06437 7.18312 2.46937 7.79344 2.3625C8.19844 2.28937 8.60344 2.25281 9 2.25281C12.7209 2.25281 15.75 5.28187 15.75 9.00281C15.75 12.3412 13.3144 15.12 10.125 15.6572V8.36156L11.5847 9.80437C12.0262 10.2403 12.7378 10.2375 13.1766 9.79594C13.6125 9.35438 13.6097 8.64281 13.1681 8.20406L11.2163 6.27469C10.62 5.67844 9.82406 5.34938 8.98031 5.34938C8.13656 5.34938 7.34062 5.67844 6.73875 6.28031L4.82625 8.21531C4.39031 8.65687 4.39312 9.36844 4.83469 9.80719C5.05406 10.0237 5.34094 10.1334 5.625 10.1334C5.90906 10.1334 6.20438 10.0209 6.42375 9.79875L7.875 8.33062V15.66C4.68563 15.1228 2.25 12.3441 2.25 9.00562C2.25 8.60906 2.28656 8.20406 2.35969 7.79906C2.46937 7.18875 2.06437 6.60375 1.45125 6.49125C0.840937 6.38156 0.255938 6.78656 0.143438 7.39969L0.14625 7.39406Z" fill="white"/>
    <path d="M3.60844 3.88972C3.65906 3.83629 3.70688 3.78004 3.74906 3.71816C3.78844 3.65629 3.82219 3.5916 3.85031 3.5241C3.87844 3.4566 3.90094 3.38629 3.915 3.31316C3.92906 3.24004 3.9375 3.16691 3.9375 3.09379C3.9375 3.02066 3.92906 2.94754 3.915 2.87441C3.90094 2.80129 3.87844 2.73097 3.85031 2.66347C3.82219 2.59597 3.78844 2.53129 3.74906 2.46941C3.70688 2.40754 3.65906 2.35129 3.60844 2.29785C3.555 2.24722 3.49875 2.19941 3.43687 2.15722C3.375 2.11785 3.31031 2.0841 3.24281 2.05597C3.17531 2.02785 3.105 2.00535 3.03188 1.99129C2.66625 1.91816 2.27813 2.03629 2.01656 2.29785C1.96594 2.35129 1.91813 2.40754 1.87594 2.46941C1.83656 2.53129 1.80281 2.59597 1.77469 2.66347C1.74656 2.73097 1.72406 2.80129 1.71 2.87441C1.69594 2.94754 1.6875 3.02066 1.6875 3.09379C1.6875 3.3891 1.80844 3.6816 2.01656 3.88972C2.22469 4.09785 2.51438 4.21879 2.8125 4.21879C3.11063 4.21879 3.40031 4.09785 3.60844 3.88972Z" fill="white"/>
    </svg>)
};
export const TicketIcon = ({color=''}) => {
  return (
    <svg className="icon" xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17" >
    <path fill={color} d="M11.6637 0H2.33627C1.04538 0 0 1.0391 0 2.32043V14.6796C0 15.9609 1.04538 17 2.33627 17H11.6645H11.6637C12.9546 17 14 15.9609 14 14.6796V2.32043C14 1.70526 13.7545 1.11478 13.3157 0.679706C12.8776 0.244629 12.2839 0 11.6637 0ZM12.4427 14.6788V14.6796C12.4427 15.1067 12.0937 15.4525 11.6637 15.4525H2.33627C1.90624 15.4525 1.55724 15.1067 1.55724 14.6796V2.32041C1.55724 1.89329 1.90624 1.54746 2.33627 1.54746H11.6645H11.6637C12.0938 1.54746 12.4428 1.89329 12.4428 2.32041L12.4427 14.6788ZM11.6637 8.5C11.6661 8.70399 11.5859 8.90081 11.4415 9.04664C11.2971 9.19167 11.0997 9.27375 10.8935 9.27375H10.1145H10.1153C9.68524 9.27375 9.33625 8.92712 9.33625 8.5C9.33625 8.07288 9.68524 7.72625 10.1153 7.72625H10.8943H10.8935C11.0997 7.72625 11.2971 7.80833 11.4415 7.95336C11.5859 8.09918 11.6661 8.29601 11.6637 8.5ZM8.55723 8.5C8.55723 8.92712 8.20904 9.27375 7.779 9.27375H3.10645C2.67641 9.27375 2.32742 8.92712 2.32742 8.5C2.32742 8.07288 2.67641 7.72625 3.10645 7.72625H7.779C7.98519 7.72625 8.18337 7.80833 8.32938 7.95336C8.47539 8.09839 8.55723 8.29521 8.55723 8.5ZM7.779 11.5942C7.779 12.0213 7.43001 12.3671 6.99997 12.3671H3.10646C2.67642 12.3671 2.32742 12.0213 2.32742 11.5942C2.32742 11.1671 2.67642 10.8204 3.10646 10.8204H6.99997C7.20616 10.8204 7.40434 10.9017 7.55035 11.0467C7.69636 11.1918 7.779 11.3886 7.779 11.5942ZM11.6725 5.40585C11.6725 5.83297 11.3235 6.17959 10.8935 6.17959H7.779C7.34896 6.17959 6.99997 5.83297 6.99997 5.40585C6.99997 4.97872 7.34896 4.63289 7.779 4.63289H10.8943H10.8935C11.1005 4.63289 11.2987 4.71417 11.4447 4.8592C11.5907 5.00423 11.6725 5.20106 11.6725 5.40585ZM2.33626 5.40585C2.33385 5.20185 2.41408 5.00504 2.55848 4.86C2.70289 4.71418 2.90027 4.63289 3.10646 4.63289H5.44273C5.87277 4.63289 6.22096 4.97872 6.22096 5.40585C6.22096 5.83297 5.87277 6.17959 5.44273 6.17959H3.10646C2.90027 6.17959 2.70291 6.09752 2.55848 5.95249C2.41407 5.80746 2.33383 5.61063 2.33626 5.40585Z" />
    </svg>)
};
